import headerImageDjango from '@static/header/codemymobile_website_2_blue_white_-Django.jpg';
import DjangoScalableIcon from '@assets/technologies/django/Scalable.svg';
import DjangoVersatileIcon from '@assets/technologies/django/Versatile.svg';
import DjangoOpenSourceIcon from '@assets/technologies/django/OpenSource.svg';
import DjangoLoadedIcon from '@assets/technologies/django/Loaded.svg';
import CarefullySelectedTeamIcon from '@assets/technologies/django/Carefully-Selected-Team.svg';
import CostEffectivePricesIcon from '@assets/technologies/django/Versatile.svg';
import DifferentEngagementModelsIcon from '@assets/technologies/django/Different-Engagement-Models.svg';
import QualityCentricDevelopmentIcon from '@assets/technologies/django/Quality-Centric-Development.svg';
import TransparentWorkingMethodologyIcon from '@assets/technologies/django/Transparent-Working-Methodology.svg';

import headerImageGatsbyJS from '@static/header/codemymobile_website_2_blue_white_GatsbyJS.jpg';
import GatsbyFastIcon from '@assets/technologies/gatsby/Fast.svg';
import GatsbyFuturisticIcon from '@assets/technologies/gatsby/Futuristic.svg';
import GatsbyPerformanceIcon from '@assets/technologies/gatsby/Performance.svg';
import GatsbySecureIcon from '@assets/technologies/gatsby/Secure.svg';
import CostEffectiveServicesIcon from '@assets/technologies/gatsby/Cost-Effective-Services.svg';
import FlexibleWorkCultureIcon from '@assets/technologies/gatsby/Flexible-Work-Culture.svg';
import IPProtectionSecurityIcon from '@assets/technologies/gatsby/IP-Protection-and-Security.svg';
import ProgressCoverageIcon from '@assets/technologies/gatsby/Progress-Coverage.svg';
import SkilledExperiencedIcon from '@assets/technologies/gatsby/Skilled-and-Experienced.svg';

import headerImageLaravel from '@static/header/codemymobile_website_2_blue_white_-Laravel.jpg';
import LaravelMigrationIcon from '@assets/technologies/laravel/Migration.svg';
import LaravelFeaturesIcon from '@assets/technologies/laravel/Features.svg';
import LaravelDifferentIcon from '@assets/technologies/laravel/Different.svg';
import LaravelEfficientIcon from '@assets/technologies/laravel/Efficient.svg';
import FlexibleMigrationOptionsIcon from '@assets/technologies/laravel/Flexible-migration-options.svg';
import OffersSurplusArtisticIcon from '@assets/technologies/laravel/Offers-a-surplus-of-artistic.svg';
import FacilitatesVersionControlIcon from '@assets/technologies/laravel/Facilitates-version-control-for.svg';
import InstinctivePackagingSystemIcon from '@assets/technologies/laravel/Instinctive-packaging-system-brings.svg';
import FinalSolutionUpgradeableIcon from '@assets/technologies/laravel/Makes-the-final-solution-upgradeable.svg';
import FlexibilityScalabilityIcon from '@assets/technologies/laravel/Flexibility-and-scalability-during-the.svg';
import RobustSecurityIcon from '@assets/technologies/laravel/Robust-security.svg';

import headerImageShopify from '@static/header/codemymobile_website_2_blue_white_Shopify.jpg';
import ShopifyEasySetupIcon from '@assets/technologies/shopify/Easy-setup-and-launching-without.svg';
import ShopifyFastSecureHostingIcon from '@assets/technologies/shopify/Fast-and-secure-hosting.svg';
import ShopifyCustomerInfoSecuredIcon from '@assets/technologies/shopify/Customer-info-is-kept-secured.svg';
import ShopifyReviewsIcon from '@assets/technologies/shopify/Gives-reviews.svg';
import ShopifySecurePaymentGatewayIcon from '@assets/technologies/shopify/Secure-payment-gateway.svg';
import ShopifySEOEfficientIcon from '@assets/technologies/shopify/SEO-efficient.svg';
import Shopify24x7AssistanceIcon from '@assets/technologies/shopify/shopify-24x7-assistance.svg';
import OutstandingUserExperienceIcon from '@assets/technologies/shopify/Outstanding-User-Experience-across-all.svg';
import MultPaymentOptionsSupportIcon from '@assets/technologies/shopify/Multiple-payment-options-supporting.svg';
import SecurityPCIComplianceSSLIcon from '@assets/technologies/shopify/Security-from-PCI-Compliance-to-SSL.svg';
import EasyContentManagementIcon from '@assets/technologies/shopify/Easily-management-content.svg';
import RobustBugFreeStoreIcon from '@assets/technologies/shopify/A-robust--bug-free-Shopify-store.svg';
import ScalableSolutionIcon from '@assets/technologies/shopify/A-Scalable-Solution.svg';
import ModernUIUXIcon from '@assets/technologies/shopify/Modern-UI-UX-to-captivate-your-visitors.svg';
import EngagingExperienceIcon from '@assets/technologies/shopify/An-engaging-experience-for-your.svg';
import CustomizeAllNeedsIcon from '@assets/technologies/shopify/Customize-All-You-Need.svg';
import WarehouseInventoryManagementIcon from '@assets/technologies/shopify/Warehouse-and-Inventory-Management.svg';

import headerImageExpressJS from '@static/header/codemymobile_website_2_blue_white_ExpressJS.jpg';
import ExpressJSRoutingIcon from '@assets/technologies/express-js/Routing.svg';
import ExpressJSDebuggingIcon from '@assets/technologies/express-js/Debugging.svg';
import ExpressJSTemplatingIcon from '@assets/technologies/express-js/Templating.svg';
import ExpressJSMiddlewareIcon from '@assets/technologies/express-js/Middleware.svg';
import ExpressJSSkilledExperiencedIcon from '@assets/technologies/express-js/Skilled-and-Experienced.svg';
import ExpressJSProgressCoverageIcon from '@assets/technologies/express-js/Progress-Coverage.svg';
import ExpressJSIPProtectionSecurityIcon from '@assets/technologies/express-js/IP-Protection-and-Security.svg';
import ExpressJSFlexibleWorkCultureIcon from '@assets/technologies/express-js/Flexible-Work-Culture.svg';
import ExpressJSCostEffectiveServicesIcon from '@assets/technologies/express-js/Cost-Effective-Services.svg';

import headerImageDocker from '@static/header/codemymobile_website_2_blue_white_-Docker.jpg';
import DockerSimplicityIcon from '@assets/technologies/docker/Simplicity.svg';
import DockerAgilityIcon from '@assets/technologies/docker/Agility.svg';
import DockerChoiceIcon from '@assets/technologies/docker/Choice.svg';
import DockerSecureIcon from '@assets/technologies/docker/Secure.svg';
import DockerCertifiedEngineersIcon from '@assets/technologies/docker/Docker-Certified-Engineers.svg';
import SixPlusYearsExperienceIcon from '@assets/technologies/docker/six-plus-years-of-experience.svg';

import headerImageElasticSearch from '@static/header/codemymobile_website_2_blue_white_-ElasticSearch.jpg';
import ElasticSearchSpeedIcon from '@assets/technologies/elastic-search/speed.svg';
import ElasticSearchScalabilityIcon from '@assets/technologies/elastic-search/Scalability.svg';
import ElasticSearchFineTuningIcon from '@assets/technologies/elastic-search/Fine-tuning.svg';
import ElasticSearchDistributionIcon from '@assets/technologies/elastic-search/Distribution.svg';
import ElasticSearchCarefullySelectedTeamIcon from '@assets/technologies/elastic-search/Carefully-Selected-Team.svg';
import TenPlusYearsExperienceIcon from '@assets/technologies/elastic-search/ten-plus-years-of-experience.svg';
import OnTimeDeliveryIcon from '@assets/technologies/elastic-search/On-time-delivery-of-project.svg';
import FlexibilityToChooseIcon from '@assets/technologies/elastic-search/Flexibility-to-choose-hourly-or-fixed-cost-engagement.svg';
import RoundClockSupportIcon from '@assets/technologies/elastic-search/Round-the-Clock-Supports.svg';

import headerImageAWS from '@static/header/codemymobile_website_2_blue_white_Amazon-Web-Service.jpg';
import AWSFlexibilityIcon from '@assets/technologies/aws/Flexibility.svg';
import AWSCostEffectiveIcon from '@assets/technologies/aws/Cost-effective.svg';
import AWSScalableElasticIcon from '@assets/technologies/aws/Scalable-and-Elastic.svg';
import AWSSecureIcon from '@assets/technologies/aws/Secure.svg';
import AWSCloudSupportIcon from '@assets/technologies/aws/AWS-Cloud-Support-from-start-to-the-end-life-cycle-of-the-project.svg';
import DisasterRecoveryIcon from '@assets/technologies/aws/Disaster-recovery-DR-of-client-application--data-redundancy.svg';
import MonitorUsageOfResourcesIcon from '@assets/technologies/aws/Our-monitoring-system-will-monitor-the-usage-of-each-AWS-resource.svg';
import RealTimePerformanceOptimizationIcon from '@assets/technologies/aws/Application-performance-optimization-based-on-real-time-load.svg';
import AWSCloudTechnicalSupportIcon from '@assets/technologies/aws/AWS-Cloud-technical-support.svg';

import headerImageAngularJS from '@static/header/codemymobile_website_2_blue_white_AngularJS.jpg';
import AngularJSCrossPlatformIcon from '@assets/technologies/angular-js/Cross-Platform.svg';
import AngularJSSpeedPerformanceIcon from '@assets/technologies/angular-js/Speed--Performance.svg';
import AngularJSSEOFriendlyIcon from '@assets/technologies/angular-js/SEO-Friendly.svg';
import AngularJSEntireEcosystemIcon from '@assets/technologies/angular-js/Entire-Ecosystem.svg';
import AngularJSAgileIcon from '@assets/technologies/angular-js/Agile-AngularJS-design-and-development-methodology.svg';
import AwardWinningSolutionIcon from '@assets/technologies/angular-js/Award-winning-mobile-and-web-solutions.svg';
import AngularJSCollaborativeIcon from '@assets/technologies/angular-js/Collaborative.svg';
import CompetitiveRatesIcon from '@assets/technologies/angular-js/Competitive-rates-for-AngularJS-developers-and-architects.svg';
import ExpertsInHTML5Icon from '@assets/technologies/angular-js/Experts-in-HTML5-frameworks-SproutCore.svg';
import AngularJSInHouseIcon from '@assets/technologies/angular-js/In-house.svg';
import SuccessfulProjectDeliveryIcon from '@assets/technologies/angular-js/Proven-track-record-of-successful-HTML5-mobile-project-delivery.svg';
import RigorousQualityAssuranceIcon from '@assets/technologies/angular-js/Rigorous-quality-assurance-QA-testing-before-Go-Live.svg';
import AngularJSRapidIcon from '@assets/technologies/angular-js/Rapid.svg';

import headerImageReactJS from '@static/header/codemymobile_website_2_blue_white_ReactJS_section_02.jpg';
import ReactJSComponentBased from '@assets/technologies/react-js/Component-Based.svg';
import ReactJSDeclarative from '@assets/technologies/react-js/Declarative.svg';
import ReactJSEasyLearningCurve from '@assets/technologies/react-js/Easy-Learning-Curve.svg';
import ReactJSResponsiveUI from '@assets/technologies/react-js/Responsive-UI.svg';
import ReactJSUsefulnessOfJFX from '@assets/technologies/react-js/Usefulness-of-JFX.svg';
import ReactJSSeamlessIntegration from '@assets/technologies/react-js/Seamless-Integration.svg';
import ReactJSFeatureRichWebsite from '@assets/technologies/react-js/Feature-rich-website.svg';
import ReactJSEasyMigration from '@assets/technologies/react-js/Easy-Migration.svg';
import ReactJSBestInClassDevelopers from '@assets/technologies/react-js/Best-in-class-Developers.svg';
import ReactJSAgileMethodology from '@assets/technologies/react-js/Agile-Methodology.svg';
import ReactJSTrendingTechnologiesUsed from '@assets/technologies/react-js/Trending-Technologies-Used.svg';

import headerImageReactNative from '@static/header/codemymobile_website_2_blue_white_-React-Native_section_02.jpg';
import ReactNativeCodeReusability from '@assets/technologies/react-native/Code-Reusability-Reduces-Overall-Development-Time.svg';
import ReactNativeCostEffective from '@assets/technologies/react-native/Cost-effective.svg';
import ReactNativeCoversTwoMajor from '@assets/technologies/react-native/Covers-Two-Major.svg';
import ReactNativeHighPerformance from '@assets/technologies/react-native/High-performance-apps.svg';
import ReactNativeHugeSupport from '@assets/technologies/react-native/Huge-support.svg';
import ReactNativeIncorporateTheFunctionality from '@assets/technologies/react-native/Incorporate-the-functionality-of-other-native-apps.svg';
import ReactNativeLiveUpdates from '@assets/technologies/react-native/Live-Updates-and-CodePush.svg';
import ReactNativeNativeness from '@assets/technologies/react-native/Nativeness.svg';
import ReactNativeSeamleassAnimations from '@assets/technologies/react-native/Seamleass-animations.svg';
import ReactNativeShorterDevelopmentCycles from '@assets/technologies/react-native/Shorter-Development-Cycles.svg';
import ReactNativeTransformation from '@assets/technologies/react-native/Transformation.svg';
import ReactNativeTrustedByBigBrands from '@assets/technologies/react-native/Trusted-by-big-brands.svg';
import ReactNativeUIFocused from '@assets/technologies/react-native/UI-Focused.svg';

import headerImageMongoDB from '@static/header/codemymobile_website_2_blue_white_-MongoDB_section_01.jpg';
import MongoDBDuplication from '@assets/technologies/mongodb/Duplication.svg';
import MongoDBFlexibility from '@assets/technologies/mongodb/Flexibility.svg';
import MongoDBOurConsultantsEnable from '@assets/technologies/mongodb/Our-consultants-enable-you-to-implement-MongoDB-solutions.svg';
import MongoDBPersonalizationAtEveryStep from '@assets/technologies/mongodb/Personalization-at-every-step.svg';
import MongoDBReplication from '@assets/technologies/mongodb/Replication.svg';
import MongoDBRichFeatures from '@assets/technologies/mongodb/Rich-Features.svg';
import MongoDBWeHelpBusinessesMigrate from '@assets/technologies/mongodb/We-help-businesses-migrate-data-from-RDBMS-to-NoSQL-like-MongoDB.svg';
import MongoDBWeProvideCleanCodes from '@assets/technologies/mongodb/We-provide-clean-codes.svg';
import MongoDBAgileDevelopmentMethodology from '@assets/technologies/mongodb/We-provide-the-best-suited-Agile-development-methodology.svg';
import MongoDBBackingUp from '@assets/technologies/mongodb/We-track-your-databases-for-backing-up-your-data.svg';
import MongoDBMobileApps from '@assets/technologies/mongodb/We-use-Xcode-and-Android-SDK-to-develop-robust-mobile-apps-with-MongoDB.svg';

import headerImageGoogleCloud from '@static/header/codemymobile_website_2_blue_white_-Google-Cloud.jpg';
import GoogleCloudManagedVmsIcon from '@assets/technologies/google-cloud/Managed-Vms.svg';
import GoogleCloudReplicaPoolsIcon from '@assets/technologies/google-cloud/Replica-pools.svg';
import GoogleCloudKubernotesIcon from '@assets/technologies/google-cloud/Kubernotes.svg';
import BetterPricingPlansIcon from '@assets/technologies/google-cloud/Better-Pricing-Plans.svg';
import LiveMigrationIcon from '@assets/technologies/google-cloud/Live-migration.svg';
import RedundantBackupsIcon from '@assets/technologies/google-cloud/Redundant-Backups.svg';
import ControlAndSecurityecurityIcon from '@assets/technologies/google-cloud/Control--security.svg';

import JavaHeaderImage from '@assets/technologies/java/java-header.jpg';
import JavaSecureIcon from '@assets/technologies/java/Secure.svg';
import JavaHighPerformance from '@assets/technologies/java/High-Performance.svg';
import JavaMultiThreaded from '@assets/technologies/java/Multi-Threaded.svg';
import JavaDynamic from '@assets/technologies/java/Dynamic.svg';
import JavaRichPerformance from '@assets/technologies/java/Rich-performance.svg';
import JavaInteroperable from '@assets/technologies/java/Interoperable.svg';
import JavaErrorFree from '@assets/technologies/java/Error-free-multithreading.svg';
import JavaOfficialLanguage from '@assets/technologies/java/Official-language.svg';
import JavaHighlySkill from '@assets/technologies/java/Highly-skilled-experienced.svg';
import JavaKotlinTeam from '@assets/technologies/java/Dedicated-Kotlin-Team.svg';
import JavaFixedCost from '@assets/technologies/java/Flexibility-to-choose-hourly-or.svg';
import JavaSeamless from '@assets/technologies/java/Seamless-communication.svg';
import JavaDisclosure from '@assets/technologies/java/Non-Disclosure-Agreement.svg';
import JavaOnTimeDelivery from '@assets/technologies/java/Ontime-delivery-of-the-project.svg';
import JavaTechnicalSupport from '@assets/technologies/java/Technical-support.svg';

import NodeHeaderImage from '@assets/technologies/nodejs/header-nodejs.jpg';
import NodeWebEfficient from '@assets/technologies/nodejs/Website-Efficient.svg';
import NodeEasyInstall from '@assets/technologies/nodejs/Easy-installation-and-execution.svg';
import NodeScalable from '@assets/technologies/nodejs/Scalable-development.svg';
import NodeEcomm from '@assets/technologies/nodejs/Swift-eCommerce-site-handling.svg';
import NodeParsingTime from '@assets/technologies/nodejs/Reduced-parsing-time.svg';
import NodeAllPlatform from '@assets/technologies/nodejs/Compatibility-on-all-platforms.svg';
import NodeServerSide from '@assets/technologies/nodejs/Networking-applications-connected.svg';
import NodeAPIIntegration from '@assets/technologies/nodejs/API-integration-and-development.svg';
import NodeCustomisedApp from '@assets/technologies/nodejs/Customised-apps.svg';
import NodeCloud from '@assets/technologies/nodejs/Hosted-on-cloud.svg';
import NodeMultipleApp from '@assets/technologies/nodejs/Multiple-application.svg';
import NodeContentPortal from '@assets/technologies/nodejs/Content-management-portals.svg';
import NodePlugin from '@assets/technologies/nodejs/Plugins-development.svg';
import NodeChatApp from '@assets/technologies/nodejs/Chat-applications.svg';
import NodeRealTime from '@assets/technologies/nodejs/Real-time-apps.svg';
import NodeEcommPortal from '@assets/technologies/nodejs/eCommerce-portals.svg';
import NodeMonitoring from '@assets/technologies/nodejs/System-monitoring-applications.svg';
import NodeDateIntensiveApp from '@assets/technologies/nodejs/Light-weight-data-intensive-apps.svg';
import NodeCreateMarket from '@assets/technologies/nodejs/Creating-Marketplace.svg';
import NodeAjaxDev from '@assets/technologies/nodejs/Ajax-development.svg';
import NodeWebAPI from '@assets/technologies/nodejs/Web-APIs.svg';
import NodeRealTimeApps from '@assets/technologies/nodejs/Real-time-apps.svg';
import NodeAPIPs from '@assets/technologies/nodejs/APIs.svg';

import PostgreHeader from '@assets/technologies/postgre/header-postgre.jpg';
import PostgreCompatible from '@assets/technologies/postgre/Compatible.svg';
import PostgreSupport from '@assets/technologies/postgre/Support.svg';
import PostgreSecure from '@assets/technologies/postgre/Secure.svg';
import PostgreVariety from '@assets/technologies/postgre/Variet.svg';
import PostgreWorldClass from '@assets/technologies/mysql/World-class-developers.svg';
import PostgreClientSatifaction from '@assets/technologies/mysql/Deliver-ultimate-client-satisfaction.svg';
import PostgreDatabase from '@assets/technologies/mysql/We-track-your-databases-for-backing-up-your-data.svg';
import PostgreMobileApp from '@assets/technologies/mysql/We-use-Xcode-and-Android-SDK-to-develop-robust-mobile-apps-with-MySQL.svg';
import PostgreAgileDev from '@assets/technologies/mysql/We-provide-the-best-suited-Agile-development-methodology.svg';
import PostgrePersonalization from '@assets/technologies/mysql/Personalization-at-every-step.svg';
import headerImageSwiftObjectiveC from '@static/header/codemymobile_website_2_blue_white_-Swift-Objective-C_section_01.jpg';
import SwiftObjectiveCCustomizedScalable from '@assets/technologies/swift-objectiveC/Customized--Scalable.svg';
import SwiftObjectiveCDynamicTypinge from '@assets/technologies/swift-objectiveC/Dynamic-Typing.svg';
import SwiftObjectiveCEasyAddOns from '@assets/technologies/swift-objectiveC/Easy-Add-Ons.svg';
import SwiftObjectiveCExpressiveMessageSyntax from '@assets/technologies/swift-objectiveC/Expressive-Message-Syntax.svg';
import SwiftObjectiveCFastMethods from '@assets/technologies/swift-objectiveC/Fast-Methods.svg';
import SwiftObjectiveCFocusedonBusinessGoals from '@assets/technologies/swift-objectiveC/Focused-on-Business-Goals.svg';
import SwiftObjectiveCHighPerformance from '@assets/technologies/swift-objectiveC/High-Performance.svg';
import SwiftObjectiveCModern from '@assets/technologies/swift-objectiveC/Modern.svg';
import SwiftObjectiveCOfficailLanguage from '@assets/technologies/swift-objectiveC/Officail-language.svg';
import SwiftObjectiveCOnTimeDelivery from '@assets/technologies/swift-objectiveC/On-Time-Delivery.svg';
import SwiftObjectiveCPerfectBlend from '@assets/technologies/swift-objectiveC/Perfect-Blend.svg';
import SwiftObjectiveCResultOrientedStrategy from '@assets/technologies/swift-objectiveC/Result-Oriented-Strategy.svg';
import SwiftObjectiveCTransparentApproach from '@assets/technologies/swift-objectiveC/Transparent-Approach.svg';
import SwiftObjectiveCUpdatedTechnologies from '@assets/technologies/swift-objectiveC/Updated-Technologies.svg';

import { FeaturePackedSoftwareIcon } from '@components/Svg';
import headerImageJavaScript from '@static/header/codemymobile_website_2_blue_white_-JavaScript_section_02.jpg';
import JavaScriptIsEasyIcon from '@assets/technologies/javascript/JavaScript-is-easy.svg';
import JavaScriptRichFrontEndIcon from '@assets/technologies/javascript/Provides-rich-front-end.svg';
import JavaScriptVisualEffectIcon from '@assets/technologies/javascript/Create-visual-effects-on-screen.svg';
import JavaScriptClientSideIcon from '@assets/technologies/javascript/Used-on-the-client-side-Relieves-strain-on-the-web-server.svg';
import JavaScriptProcessImmediatelyIcon from '@assets/technologies/javascript/Processing-is-done-immediately.svg';
import ResponsiveUIIcon from '@assets/technologies/javascript/Responsive-UI.svg';
import SeamlessIntegrationIcon from '@assets/technologies/javascript/Seamless-Integration.svg';
import FeatureRickWebsiteIcon from '@assets/technologies/javascript/Feature-rich-website.svg';
import EasyMigrationIcon from '@assets/technologies/javascript/Easy-Migration.svg';
import BestInClassDevlopersIcon from '@assets/technologies/javascript/Best-in-class-Developers.svg';
import JavascriptAgileMethodologyIcon from '@assets/technologies/javascript/Agile-Methodology.svg';
import TrendingTechnologiesUsedIcon from '@assets/technologies/javascript/Trending-Technologies-Used.svg';

const aws = {
  title: 'Amazon Web Service (AWS)',
  overview:
    'Large applications require complete management to allow them to scale to meet the challenges of ever-changing requirements and to maintain the levels of service required by users. Amazon Web Services (AWS) is a cloud-based program used for fabricating solutions for firms using inter-connected web services. It also provides various pre-built services which can benefit businesses to build their custom cloud-based solutions.\nHere at CodeMyMobile, we recognise and understand the demand for high availability application solutions and thus, we provide industry-specific IaaS (Infrastructure as a Solution) with AWS to excel your trade. Our team of expert AWS architects has successfully deployed several mobile and web apps of various industries to AWS cloud.',
  headerImage: headerImageAWS,
  technologyFeatures: {
    title: 'Features of Amazon Web Service (AWS)',
    items: [
      {
        icon: AWSFlexibilityIcon,
        title: 'Flexibility',
        description:
          'The flexibility of AWS allows us to choose which programming models, languages, and OS are better accommodated for your project. Which then turns into a more efficient infrastructure overall. Fabricating applications in AWS are like building applications using existing hardware resources.',
      },
      {
        icon: AWSCostEffectiveIcon,
        title: 'Cost-effective',
        description:
          'AWS provides no upfront investment, long-term commitment, or minimum spend. You can scale up or scale down as the demand for resources increases or decreases respectively.',
      },
      {
        icon: AWSScalableElasticIcon,
        title: 'Scalable and Elastic',
        description:
          "AWS's elasticity balances load and its scalability automatically scale your AWS computing resources, to meet unexpected demands and to scale down when demand lessens. The AWS cloud is also useful for implementing short-term jobs, mission-critical jobs, and the jobs repeated at regular intervals.",
      },
      {
        icon: AWSSecureIcon,
        title: 'Secure',
        description:
          "An AWS infrastructure is incorporated in AWS controlled data centres throughout the globe. The data centres are physically secured to prevent illicit access. Each service provided by the AWS cloud is secure so users don't need to worry about data privacy.",
      },
    ],
  },
  whyTechnology: {
    title: 'Why AWS?',
    items: [
      {
        list: [
          'Zero CapEx',
          'No-Commitment',
          'Get Rid of Negotiations',
          'Pay Per Use',
        ],
      },
      {
        list: [
          'Highly Secure',
          'Global Leaders',
          'Best-in-class PaaS Offerings',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: AWSCloudSupportIcon,
        title:
          'AWS Cloud Support from start to the end life cycle of the project',
      },
      {
        icon: DisasterRecoveryIcon,
        title: 'Disaster recovery (DR) of client application & data redundancy',
      },
      {
        icon: MonitorUsageOfResourcesIcon,
        title:
          'Our monitoring system will monitor the usage of each AWS resource',
      },
      {
        icon: RealTimePerformanceOptimizationIcon,
        title: 'Application performance optimization based on real-time load',
      },
      {
        icon: AWSCloudTechnicalSupportIcon,
        title: 'AWS Cloud technical support',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'AWS cloud deployment for web and mobile apps',
          'AWS cloud migration',
          'Configured AWS cloud solutions',
          'End to end integration',
          'AWS Cloud maintenance and support',
        ],
      },
    ],
  },
};

const docker = {
  title: 'Docker',
  overview:
    "Let's take a throw scenario of a developer and a tester. Before you had the world of docker, a developer would actually build their code and then they'd send it to the tester but then the code wouldn't work on their system due to the differences in computer environments so what could be the solution to this? Well, you could go ahead and create a virtual machine to be the same as the solution in both areas. But Docker is an even better solution.\nA big difference is that the guest OS has not been used in Docker and is inherently more lightweight but provides the same functionality as a virtual machine.\nLet’s take a scenario of DevOps. Integration between developers and operators group. Developers are interested in planning, coding, building and testing and Operators want to be able to efficiently deploy, operate and monitor.\nWhen you can have both groups interacting with each other on these seven keys and elements then you can have the efficiencies of an excellent DevOps team.\nSo let's step deeper into what docker is. So docker is a tool which is used to automate the deployment applications in a lightweight container so the application can work efficiently in different environments. Now it's important to note that the container is a software package that consists of all the dependencies required to run the application. So multiple containers can run on the same hardware, the containers are maintained in isolated environments, they're highly productive and they're quick and easy to configure.\nSo let's take an example of what Docker is by using a house that may be rented for someone using Airbnb so in the house. There are three rooms and only one cupboard and the problem we have is that none of the guests is ready to share the cupboard.\nThis is very similar to how we run software applications today. Each of the applications could end up using different frameworks. This is where docker will help you run the applications with a suitable framework. So let's go back to our Airbnb example, so we have three rooms and a cupboard. How to resolve this issue? Well, we can put a cupboard in each room. We can do the same thing for computers. Docker provides suitable frameworks for each different application and since every application has a framework with a suitable version.\nSince every application has its framework and a suitable version of the area that we had previously stored for a framework can be used for something else now we can create a new application.\nHere at CodeMyMobile, our experienced team provides all sorts of Docker solutions from implementation to its maintenance and anything that comes between this process, anything that you can think of.",
  headerImage: headerImageDocker,
  technologyFeatures: {
    title: 'Features of Docker',
    items: [
      {
        icon: DockerSimplicityIcon,
        title: 'Simplicity',
        description:
          'Docker provides developer-friendly, CLI-based workflow and makes it easy to build, share, and run containerized applications.',
      },
      {
        icon: DockerAgilityIcon,
        title: 'Agility',
        description:
          'Docker is easy to configure and helps you speed up your workflows. Docker even accelerates the migration of applications from the data centre to the cloud.',
      },
      {
        icon: DockerChoiceIcon,
        title: 'Choice',
        description:
          'Docker offers you the broadest choice. Build, share and run applications across any combination of clouds, operating systems, languages and frameworks.',
      },
      {
        icon: DockerSecureIcon,
        title: 'Secure',
        description:
          'Applications are safer in containers and Docker provides the strongest default isolation capabilities in the industry',
      },
    ],
  },
  whyTechnology: {
    title: 'Why Docker?',
    items: [
      {
        list: [
          "Doesn't need a guest OS for each container",
          'Occupies less memory than VMs',
          'Very fast boot up',
          'Better performance',
        ],
      },
      {
        list: [
          'Effortless to set up',
          'Easier to port docker across multiple platforms',
          'Simple to scale thus highly efficient',
          'No need to include the guest, thus eliminating a significant amount of space',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: SixPlusYearsExperienceIcon,
        title: '6+ years of experience',
      },
      {
        icon: DockerCertifiedEngineersIcon,
        title: 'Docker Certified Engineers',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'We replace Large Monolithic Applications with Microservices',
          'Cloud Platform Cost Optimisation',
        ],
      },
      {
        list: [
          'Continuous Integration, Continuous Delivery/Deployment (CI/CD)',
          'Setup Orchestration using Docker Swarm, K8s & AWS ECS',
        ],
      },
    ],
  },
};

const elasticSearch = {
  title: 'ElasticSearch',
  overview:
    "What is ElasticSearch? It is kind of like a database and search engine on steroids. What? That didn't make any sense. Well, it's a technology that allows you to implement a solution when you've got more data than you know what to do with. A basic example would be, searching for big data fast. It is like your own in-house mini Google.\nAlso, it's more like a decision-making tool. Let's imagine a scenario, remember how it was 5-10 years ago when the best you had was a relational database and you had to craft some pretty rigid statements to find what you're looking for and you could only find what you're looking for (because come on, something extra never disappoints). But with ElasticSearch, you can say 'what if?'. Whatever is needed at the right time, at the right place and the right data in the right context, it provides you. ElasticSearch cares about the numbers as well, unlike your day-to-day search engines, which only cares about the text.\nWhether you're a multi-national company operating in multiple languages across different geographies, different domains, ElasticSearch has a way to pull the required information to one place.",
  headerImage: headerImageElasticSearch,
  technologyFeatures: {
    title: 'Features of  ElasticSearch',
    items: [
      {
        icon: ElasticSearchSpeedIcon,
        title: 'Speed',
        description:
          'It can execute complex queries extremely fast. It caches almost all of the structured queries commonly used as a filter. For every other request containing a cached filter, it checks the result from the cache.',
      },
      {
        icon: ElasticSearchScalabilityIcon,
        title: 'Scalability',
        description:
          'It is a dispersed system by nature and can effortlessly scale horizontally, granting the ability to extend resources and balance the loading between the nodes in a cluster.',
      },
      {
        icon: ElasticSearchFineTuningIcon,
        title: 'Fine Tuning',
        description:
          'It allows development teams to create complex queries and fine-tune them to obtain the most accurate results from a search. It also provides a way of ranking and grouping results.',
      },
      {
        icon: ElasticSearchDistributionIcon,
        title: 'Distribution',
        description:
          'Routing and rebalancing operations are done automatically when new documents are added.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why  ElasticSearch?',
    items: [
      {
        list: [
          'Quickly finds the best matches',
          'Multilingual is supported',
          'Simple, concise, and easy to read',
          'Provides autocomplete/search-as-you-type functionality',
          'Schema-free',
          'Built to scale',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: TenPlusYearsExperienceIcon,
        title: '10+ years of experience',
      },
      {
        icon: ElasticSearchCarefullySelectedTeamIcon,
        title: 'Carefully Selected Team',
      },
      {
        icon: OnTimeDeliveryIcon,
        title: 'On-time delivery of the project',
      },
      {
        icon: FlexibilityToChooseIcon,
        title: 'Seamless communication',
      },
      {
        icon: FlexibilityToChooseIcon,
        title: 'Flexibility to choose hourly or fixed-cost engagement',
      },
      {
        icon: RoundClockSupportIcon,
        title: 'Round the Clock Supports',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'ElasticSearch Deployment',
          'Elastic Cloud Services',
          'Elasticsearch SQL',
          'Business Analytics',
        ],
      },
      {
        list: [
          'Kubernetes Monitoring',
          'Prometheus Monitoring',
          'ArcSight Integration',
          'Elastic Maps Services',
        ],
      },
    ],
  },
};

const angularJS = {
  title: 'AngularJS',
  overview:
    "For us, Angular and AngularJS is developed and maintained by Google, for you, it is designed and developed by us. Jokes apart, when it comes to AngularJS strategy, integration, design, development, custom solutions, support, maintenance and more, CodeMyMobile is your go-to spot for any sturdy Angular App development.\nOur team has been working with AngularJS since its inception. You get scalable AngularJS web applications with many great features that serve the paradoxical requirements of a business of distinct verticals.\nYou can share your unique application idea with us, and we'll make sure to develop a comprehensive AngularJS application that works perfectly for you and your users.\nOther from all the great features we provide, one other bonus from us is that our developers write clean, readable and reusable code that is free from moderators and make full use of the extensible features of AngularJS.",
  headerImage: headerImageAngularJS,
  technologyFeatures: {
    title: 'Features of Angular',
    items: [
      {
        icon: AngularJSCrossPlatformIcon,
        title: 'Cross-Platform',
        description:
          'From progressive web apps to native mobile apps with strategies from Cordova, Ionic, or NativeScript to desktop-installed apps across Mac, Windows, and Linux, Angular provides it with all.',
      },
      {
        icon: AngularJSSpeedPerformanceIcon,
        title: 'Speed and Performance',
        description:
          "From your software point of view, your software gets codes in form of templates which are highly optimized for today's JavaScript virtual machines which in turn gives you a highly optimised and seamless application, because whatever happens  at the backend is visible at the frontend.",
      },
      {
        icon: AngularJSSEOFriendlyIcon,
        title: 'SEO Friendly',
        description:
          "Who doesn't want to see their brand popping up on the front page of a Google Search (no, we're not talking about ads, duh). Due to its functionality (medium size, moderate complexity, etc.), if used correctly, there are high chances that your website might appear on the first search page.",
      },
      {
        icon: AngularJSEntireEcosystemIcon,
        title: 'Entire Ecosystem',
        description:
          'In addition to Single Page Apps (like Gmail), what makes Angular a stand-out option for front-end development is that it’s not just a JavaScript framework, it’s a whole ecosystem—thanks to the Angular Command Line Interface.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why should you choose Angular?',
    items: [
      {
        list: [
          'Has 2-way data binding capability with HTML',
          'Its Model View Controller pattern reduces development time',
          'Directives can be used to build custom widgets',
          'Helps in Localization and Internationalization',
          'Got Built-in unit testing and end-to-end (e2e) testing environment',
          'Lets you build Rich Internet Application (RIA) by writing less code',
          'Offers reusable HTML components',
          'Supports HTML vocabulary',
        ],
      },
    ],
  },
  whyUs: {
    title: 'How are we more specialized?',
    items: [
      {
        icon: AngularJSAgileIcon,
        title: 'Agile AngularJS design and development methodology',
      },
      {
        icon: AwardWinningSolutionIcon,
        title: 'Award-winning mobile and web solutions',
      },
      {
        icon: AngularJSCollaborativeIcon,
        title:
          'Collaborative, transparent and communicative client-focused approach',
      },
      {
        icon: CompetitiveRatesIcon,
        title: 'Competitive rates for AngularJS developers and architects',
      },
      {
        icon: ExpertsInHTML5Icon,
        title:
          'Experts in HTML5 frameworks SproutCore, AngularJS, Ember.js & PhoneGap',
      },
      {
        icon: AngularJSInHouseIcon,
        title:
          'In-house, front-end specialists including BAs, UX/UI & Designers',
      },
      {
        icon: SuccessfulProjectDeliveryIcon,
        title:
          'Proven track record of successful HTML5 mobile project delivery',
      },
      {
        icon: RigorousQualityAssuranceIcon,
        title: 'Rigorous quality assurance (QA) testing before “Go-Live”',
      },
      {
        icon: AngularJSRapidIcon,
        title: 'Rapid, cost-effective delivery for projects',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'AngularJS Web Development',
          'Single-Page App',
          'AngularJS Software',
        ],
      },
      {
        list: [
          'AngularJS Mobile App',
          'AngularJS Back-end',
          'Social Networking Platforms',
        ],
      },
      {
        list: [
          'Plugin and Custom Widgets',
          'Real-Time App Development',
          'Customised AngularJS Solutions',
        ],
      },
    ],
  },
};

const googleCloud = {
  title: 'Google Cloud',
  overview:
    "Need a reliable and highly scalable infrastructure for your apps? Google Cloud might be the solution you've been looking for. But what does it do? It covers application, storage and computing services for backend, mobile and web solutions. It is one of the best IaaS (Infrastructure as a Service) available out there.\nWhy do you need us? Our team full of experts will help you in advancing your IT infrastructure to Google Cloud Service. Our team has helped our clients with cost-efficient, secure, high-performing cloud solutions. Through our cloud computing services, we help you to focus more on your business and less on maintaining your infrastructure.",
  headerImage: headerImageGoogleCloud,
  technologyFeatures: {
    title: 'Features of Google Cloud',
    items: [
      {
        icon: GoogleCloudManagedVmsIcon,
        title: 'Managed VMs',
        description:
          'The Managed VM (Virtual Machine) service will check to assure that all the virtual machines are configured to the exact specs, and it will conduct any necessary upgrades during the life of the VM.',
      },
      {
        icon: GoogleCloudReplicaPoolsIcon,
        title: 'Replica Pools',
        description:
          'By this, users can create templates and have VMs automatically spun up at the same time with specific qualities.  For managers who may be working with lots of VMs and need many copies of them, this can be a great tool.',
      },
      {
        icon: GoogleCloudKubernotesIcon,
        title: 'Kubernetes',
        description:
          'By this, users can create templates and have VMs automatically spun up at the same time with specific qualities.  For managers who may be working with lots of VMs and need many copies of them, this can be a great tool.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why Google Cloud?',
    items: [
      {
        list: [
          'Higher Productivity is gained through Quick Access to Innovation',
          'Less Disruption is Caused When Users Adopt New Functionality',
          'Employees Can Work From Anywhere',
          'Google Cloud Allows Quick Collaboration',
          'Customers are protected by Google’s Investments in Security',
          'Less Data has to be stored on Vulnerable Devices',
          'Customers get Higher Uptime and Reliability',
          'Control and Flexibility Available to Users',
          'Google’s Economies of Scale Let Customers Spend Less',
        ],
      },
    ],
  },
  technologyAdvantages: {
    title: 'Advantages of Google Cloud',
    items: [
      {
        icon: BetterPricingPlansIcon,
        title: 'Better Pricing Plans Availability',
        description:
          'Google Cloud is way cheaper when compared to its competitors AWS and Azure. Google Cloud Hosting service has per sec billing plans. The main advantage of Google Cloud Hosting is that the user is not bound by its subscription if he/she has subscribed to any of the pricing plans. The subscription can be stopped at any instance.',
      },
      {
        icon: LiveMigrationIcon,
        title: 'Live Migration',
        description:
          "By having such a large network, Google Cloud Hosting allows users to migrate their machines. One big thing about this is, AWS and Azure don't provide this service.",
      },
      {
        icon: RedundantBackupsIcon,
        title: 'Redundant Backups',
        description:
          "If something is no longer required, it can be reduced, that's what redundancy is. With Google's smart AI, if some part of a component is not functioning, then Google will create a backup. By this, first, you'll get better performance and second, there's always going to be a back-up of your out-of-considerate data.",
      },
      {
        icon: ControlAndSecurityecurityIcon,
        title: 'Control and Security',
        description:
          'All the data on Cloud Platform Services is encrypted, thanks to a large number of Security Professionals Google has recruited.',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Google Cloud deployment for web and mobile apps',
          'Google Cloud migration',
          'Custom and configured Google Cloud solutions',
          'End to end integration',
          'Google Cloud maintenance and support',
        ],
      },
    ],
  },
  whyUs: {
    title: 'Why us?',
    items: [
      {
        list: [
          '10+ years of experience',
          'Certified Google Cloud Partner',
          'Google Cloud Support from start to the end life cycle of the project.',
          'Disaster recovery (DR) of client application & data redundancy.',
          'Our monitoring system will monitor the usage of each GCP resource.',
          'Application performance optimization based on real-time load.',
        ],
      },
    ],
  },
};

const django = {
  title: 'Django',
  overview:
    "Django is a Web Application Framework which is used to develop web applications. It was created to make a framework which takes less time to build a web application. Django Web Framework is preferred by most of the Python developers because it enables them to build apps with minimum coding. Due to its transparent and clean coding attributes, the entire web development process becomes highly effective and efficient.\nHere at CodeMyMobile, we have an efficient team of Django developers who can build scalable solutions including websites and applications. Following a well-systematic path to project management, we aim to deliver your project on time, thus allowing you to accomplish your business goals.\nAll we want to say is, we'll unchain the features of Django you've been looking for.",
  headerImage: headerImageDjango,
  technologyFeatures: {
    title: 'Features of Django',
    items: [
      {
        icon: DjangoScalableIcon,
        title: 'Scalable',
        description:
          'Ability to quickly and flexibly switch from small to large scale application project.',
      },
      {
        icon: DjangoVersatileIcon,
        title: 'Versatile',
        description:
          'Can be used to develop apps for various different domains like content management systems, social networks sites or scientific computing platforms, etc.',
      },
      {
        icon: DjangoOpenSourceIcon,
        title: 'Open Source',
        description:
          'It is free and can be downloaded with source code from the public repository. Open source reduces the total cost of the application development.',
      },
      {
        icon: DjangoLoadedIcon,
        title: 'Loaded',
        description:
          'Django includes various helping task modules and libraries which can be used to handle common Web development tasks. Django takes care of user authentication, content administration, site maps, RSS feeds, etc.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why Django?',
    items: [
      {
        list: ['Phenomenal Speed', 'Rich in Features'],
      },
      {
        list: ['Extremely Scalable', 'Highly Secure'],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: CarefullySelectedTeamIcon,
        title: 'Carefully Selected Team',
      },
      {
        icon: DifferentEngagementModelsIcon,
        title: 'Different Engagement Models',
      },
      {
        icon: CostEffectivePricesIcon,
        title: 'Cost-Effective Prices',
      },
      {
        icon: QualityCentricDevelopmentIcon,
        title: 'Quality-Centric Development',
      },
      {
        icon: TransparentWorkingMethodologyIcon,
        title: 'Transparent Working Methodology',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Django Web Application Development',
          'Django Website Development',
          'Django Mobile App Development',
          'Django API Development',
        ],
      },
      {
        list: [
          'Django eCommerce website/app development',
          'Django Migration',
          'Django Support and Maintenance',
        ],
      },
    ],
  },
};

const mysql = {
  title: 'MySQL',
  overview:
    'It is currently the most popular open-source database, enabling the cost-effective delivery of reliable, high-performance and scalable web-based and embedded database applications. It is an integrated transaction safe, ACID-compliant database with full commit, rollback, crash recovery, and row-level locking capabilities. MySQL can handle almost any amount of data, up to as much as 50 million rows or more. It supports various platforms including Microsoft Windows, Linux, UNIX and Mac OS. It comes with fast, multi-threaded, multi-user and rich SQL database server.\n At CodeMyMobile, with MySQL development, we create mobile apps at a faster rate with any feature, data, and any device which scales to a large number of users. Our expert consultants help you with a full range of services such as application development, migration to MySQL and scaling existing deployments.',
  headerImage: headerImageDjango,
  technologyFeatures: {
    title: 'Features of MySQL',
    items: [
      {
        icon: DjangoScalableIcon,
        title: 'Compatible',
        description:
          'It is compatible to run on many operating systems, like Novell NetWare, Windows, Linux and others. MySQL also provides a facility that the clients can run on the same computer as the server or another computer.',
      },
      {
        icon: DjangoVersatileIcon,
        title: 'Scalable',
        description:
          'It can handle almost any amount of data, up to as much as 50 million rows or more. The default file size limit is about 4 GB. However, you can increase this number to a theoretical limit of 8 TB of data.',
      },
      {
        icon: DjangoOpenSourceIcon,
        title: 'Secure',
        description:
          'It consists of a solid data security layer that protects sensitive data from intruders. Passwords are encrypted in MySQL.',
      },
      {
        icon: DjangoLoadedIcon,
        title: 'Client/Server Architecture',
        description:
          'MySQL follows a client /server architecture. There is a database server (MySQL) and arbitrarily many clients, which communicate with the server; that is, the query data, save changes, etc.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why Django?',
    items: [
      {
        list: [
          'Freely available with huge community support',
          'Various Storage Engine Options',
          'Most Popular RDBMS',
        ],
      },
      {
        list: [
          'Best suited for small and medium scale applications',
          'Feature parity with Oracle and other leading databases',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: CarefullySelectedTeamIcon,
        title: 'Carefully Selected Team',
      },
      {
        icon: DifferentEngagementModelsIcon,
        title: 'Different Engagement Models',
      },
      {
        icon: CostEffectivePricesIcon,
        title: 'Cost-Effective Prices',
      },
      {
        icon: QualityCentricDevelopmentIcon,
        title: 'Quality-Centric Development',
      },
      {
        icon: TransparentWorkingMethodologyIcon,
        title: 'Transparent Working Methodology',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'MySQL Management Services - DBA',
          'MySQL Migration Services',
          'MySQL General Consultation',
        ],
      },
      {
        list: [
          'MySQL Database Design & Implementation',
          'MySQL Scalability Services ',
          'NoSQL to MySQL Migration Services',
        ],
      },
    ],
  },
};

const gatsbyJS = {
  title: 'GatsbyJS',
  overview:
    "What is Gatsby? Gatsby is a blessing. Blessing for those whose website has been running on Wordpress for years and now they're getting slower and slower day by day because of this old working module of how it picks up data from the database for every call made by the user which makes the entire process very very slow. And to be honest, in this fast fledged world, if you're taking even a single second extra of your user's life, you're getting into huge loss because everyone is out of time and no one is ready to wait that long.\nWhat Gatsby does is it extracts all the data from the database at once without making several number calls which makes it super fast, or at least, much faster than WordPress and best suitable for static websites.\nAlmost 40% of overall websites and made on WordPress. And now most of them are rapidly shifting to Gatsby because of its working procedure.  And that's where we excel. Our developers are fully competent to migrate your existing website from any framework to Gatsby or start something from scratch on Gatsby.",
  headerImage: headerImageGatsbyJS,
  technologyFeatures: {
    title: 'Features of Gatsby',
    items: [
      {
        icon: GatsbyPerformanceIcon,
        title: 'Performance',
        description:
          'Gatsby follows the latest web standards and technologies like ReactJS, Webpack, GraphQL, modern ES6+ JavaScript and CSS.',
      },
      {
        icon: GatsbyFastIcon,
        title: 'Fast',
        description:
          'Gatsby is going beyond generating pages on request. You can make pre-build pages and upload them to the cloud to be ready for users.',
      },
      {
        icon: GatsbyFuturisticIcon,
        title: 'Futuristic',
        description:
          'Every website is an app, and every app is a website. Gatsby is becoming a very popular JavaScript framework, that more and more developers fall in love with.',
      },
      {
        icon: GatsbySecureIcon,
        title: 'Secure',
        description:
          'There is no direct connection to the database, dependencies, user data or other sensitive information.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why Gatsby?',
    items: [
      {
        list: [
          'A mix of best features of React and GraphQL',
          'You can use any number of different data files locally',
          'Ready to be delivered instantly to your users wherever they are',
        ],
      },
      {
        list: [
          'Follows the latest technology',
          'Starts from free',
          'Very secure',
          'Accessible with API',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: SkilledExperiencedIcon,
        title: 'Skilled and Experienced GatsbyJS experts',
      },
      {
        icon: ProgressCoverageIcon,
        title: 'Progress Coverage',
      },
      {
        icon: IPProtectionSecurityIcon,
        title: 'IP Protection and Security',
      },
      {
        icon: FlexibleWorkCultureIcon,
        title: 'Flexible Work Culture',
      },
      {
        icon: CostEffectiveServicesIcon,
        title: 'Cost-Effective Services',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'GastbyJS Migration',
          'GastbyJS Solutions',
          'Plug-ins Development',
          'GastbyJS Consulting',
        ],
      },
      {
        list: [
          'GastbyJS API Integration & Development',
          'GastbyJS Maintenance',
          'GastbyJS Hybrid website',
          'development',
        ],
      },
    ],
  },
};

const laravel = {
  title: 'Laravel',
  overview:
    'Need a web app? Laravel is your answer. It is the most popular PHP open-source framework for developing web applications on the platform of MVC (Model-view-controller) architecture. And thus, because of the obvious reasons, it is termed as “the PHP framework for Web Artisans” because of its dynamic inbuilt functionalities and feature-rich structure.\nCodeMyMobile understands the best methods of flexible development methodology interleaving with Laravel development services that meet the specific needs of end-user or any industry. Our Laravel developer adopted all skills of the framework to give a sturdy, real-time solution for the web application to all capital.',
  headerImage: headerImageLaravel,
  technologyFeatures: {
    title: 'Features of  Laravel',
    items: [
      {
        icon: LaravelMigrationIcon,
        title: 'Migration',
        description:
          'It offers flexible migration options and various deployment apps.',
      },
      {
        icon: LaravelFeaturesIcon,
        title: 'Features',
        description:
          'It offers templates, dependency containers and various other features.',
      },
      {
        icon: LaravelDifferentIcon,
        title: 'Different',
        description:
          'It enables a version control for databases other systems do not.',
      },
      {
        icon: LaravelEfficientIcon,
        title: 'Efficient',
        description:
          'The instinctive packaging system can help to reduce overall costs and time investments.',
      },
    ],
  },
  whyTechnology: {
    title: 'How are we more specialised?',
    items: [
      {
        list: [
          'Enterprise solutions with Laravel',
          'Laravel eCommerce solution',
          'Laravel 3rd party app integrations',
        ],
      },
      {
        list: [
          'Laravel migration solution',
          'Laravel custom theme development',
          'Laravel package development',
        ],
      },
      {
        list: [
          'Headless Laravel dev. with Angular.JS, Vue.JS',
          'Social network development with Laravel',
          'Laravel maintenance and support',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: FlexibleMigrationOptionsIcon,
        title: 'Flexible migration options',
      },
      {
        icon: OffersSurplusArtisticIcon,
        title: 'Offers a surplus of artistic templates',
      },
      {
        icon: FacilitatesVersionControlIcon,
        title: 'Facilitates version control for databases',
      },
      {
        icon: InstinctivePackagingSystemIcon,
        title: 'Instinctive packaging system brings down the cost',
      },
      {
        icon: FinalSolutionUpgradeableIcon,
        title: 'Makes the final solution upgradeable and maintainable',
      },
      {
        icon: FlexibilityScalabilityIcon,
        title: 'Flexibility and scalability during the development process',
      },
      {
        icon: RobustSecurityIcon,
        title: 'Robust security',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: ['Enterprise Solution', 'Package Development', 'Web Application'],
      },
      {
        list: [
          'RESTful Development',
          'Data Migration',
          'Custom Web Development',
        ],
      },
      {
        list: [
          'Mobile App Development',
          'E-commerce Development',
          'Maintenance And Support',
        ],
      },
    ],
  },
};

const shopify = {
  title: 'Shopify',
  overview:
    "Being a big leader in the field of e-commerce development, Shopify exists in our sub-domain. We have a dedicated in-house team of Shopify developers and proactive development approach.\nBeing a specialist Shopify development firm, we expertise in producing and developing highly customised Shopify e-stores for all business sizes.\nWe will help your eCommerce venture get off the ground at full speed. Our experience and delivery of many extraordinary solutions give us an edge to make your business succeed. We ensure a smooth digital commerce experience for your shoppers, by providing a visually appealing and technically powerful website for your brand. Let's just say that our developers are apt in delivering robust, highly secure, scalable and easily manageable online stores.",
  headerImage: headerImageShopify,
  whyTechnology: {
    title: 'Why Shopify?',
    items: [
      {
        icon: ShopifyEasySetupIcon,
        title: 'Easy setup and launching without any hassles with server',
      },
      {
        icon: ShopifyFastSecureHostingIcon,
        title: 'Fast and secure hosting',
      },
      {
        icon: ShopifyCustomerInfoSecuredIcon,
        title: 'Customer info is kept secured',
      },
      {
        icon: ShopifyReviewsIcon,
        title:
          'Gives reviews, launch loyalty programs, get in-depth analytics, etc.',
      },
      {
        icon: ShopifySEOEfficientIcon,
        title: 'SEO efficient',
      },
      {
        icon: ShopifySecurePaymentGatewayIcon,
        title: 'Secure payment gateway',
      },
      {
        icon: Shopify24x7AssistanceIcon,
        title: '24*7 assistance',
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: OutstandingUserExperienceIcon,
        title:
          'Outstanding User Experience across all intended platforms and devices',
      },
      {
        icon: MultPaymentOptionsSupportIcon,
        title: 'Multiple payment options supporting multiple currencies',
      },
      {
        icon: SecurityPCIComplianceSSLIcon,
        title:
          'Security from PCI Compliance to SSL Certificates to customized security modules',
      },
      {
        icon: EasyContentManagementIcon,
        title: 'Easily management content',
      },
      {
        icon: WarehouseInventoryManagementIcon,
        title: 'Warehouse and Inventory Management',
      },
      {
        icon: RobustBugFreeStoreIcon,
        title: 'A robust & bug-free Shopify store',
      },
      {
        icon: ScalableSolutionIcon,
        title: 'A Scalable Solution',
      },
      {
        icon: ModernUIUXIcon,
        title: 'Modern UI/UX to captivate your visitors',
      },
      {
        icon: EngagingExperienceIcon,
        title: 'An engaging experience for your buyers',
      },
      {
        icon: CustomizeAllNeedsIcon,
        title: 'Customize All You Need',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Shopify Implementation',
          'Migrate to Shopify',
          'Shopify Theme Development',
        ],
      },
      {
        list: [
          'Shopify Quality Assurance',
          '3rd Party API Integration',
          'Shopify SEO',
        ],
      },
      {
        list: [
          'Module & Plug-in development',
          'Shopify Web Design',
          'Shopify Support and Maintenance',
        ],
      },
    ],
  },
};

const expressJS = {
  title: 'ExpressJS',
  overview:
    'Express is a fast, assertive, essential and moderate web framework of NodeJS. It facilitates the rapid development of Node based Web applications. You can assume express as a layer built on the top of the NodeJS that helps manage a server and routes. It is one of the prominent components of MEAN stack.\nOur team has been working with ExpressJS since its inception. You get scalable ExpressJS server-side web applications with many great features that serve the paradoxical requirements of a business of distinct verticals.\nOther from all the great features we provide, one other bonus from us is that our developers write clean, readable and reusable code that is free from moderators and make full use of the extensible features of ExpressJS.',
  headerImage: headerImageExpressJS,
  technologyFeatures: {
    title: 'Features of Express',
    items: [
      {
        icon: ExpressJSRoutingIcon,
        title: 'Routing',
        description:
          'Routing allows a web application to preserve web page states through their URLs. ExpressJS offers a more advanced and efficient routing mechanism that can handle highly dynamic URLs.',
      },
      {
        icon: ExpressJSDebuggingIcon,
        title: 'Debugging',
        description:
          'One of the most critical tasks of us developers is knowing the source of bugs and fixing them in the fastest possible time. Fortunately, ExpressJS provides an easy debugging mechanism to empower developers to quickly point out which part of the application is causing problems.',
      },
      {
        icon: ExpressJSTemplatingIcon,
        title: 'Templating',
        description:
          'It gives a templating engine that enables web pages to have dynamic content by building HTML templates on the server-side, replacing dynamic content with their proper values, and then sending these to the client-side for rendering.',
      },
      {
        icon: ExpressJSMiddlewareIcon,
        title: 'Middleware',
        description:
          'A middleware is a chunk of code that has access to a user’s request, the application’s response, and the next middleware to be used. Express.js uses middleware to systematically arrange different function calls, giving high scalability to the application.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why AWS?',
    items: [
      {
        list: [
          'One set of engineers can handle both front- and back-end stages of a project',
          'Simple to customize and configure for certain demands',
          'Ultra-fast I/O',
          'Pay Per Use',
        ],
      },
      {
        list: [
          'Engineers are released from the necessity to repeat the same code repeatedly',
          'If you use NodeJS for producing apps, this process can be accelerated and improved with Express.',
          'Asynchronous and single-threaded',
        ],
      },
      {
        list: [
          'The working cycle is shorter; the staff doesn’t demand fresh blood, and the cross-platform capability is available.',
          'Robust API makes routing easy',
          'MVC like structure',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: ExpressJSSkilledExperiencedIcon,
        title: 'Skilled and Experienced ExpressJs experts',
      },
      {
        icon: ExpressJSProgressCoverageIcon,
        title: 'Progress Coverage',
      },
      {
        icon: ExpressJSIPProtectionSecurityIcon,
        title: 'IP Protection and Security',
      },
      {
        icon: ExpressJSFlexibleWorkCultureIcon,
        title: 'Flexible Work Culture',
      },
      {
        icon: ExpressJSCostEffectiveServicesIcon,
        title: 'Cost-Effective Services',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Express.js Solutions',
          'AJAX Development',
          'Plug-ins Development',
          'Express.js API Integration & Development',
        ],
      },
      {
        list: [
          'Express.js Consulting',
          'Express.js Maintenance',
          'Express.js Hybrid web app development',
        ],
      },
    ],
  },
};

const javascript = {
  title: 'JavaScript',
  overview:
    "It is a programming language, with which web developers can write a script and create interactive websites. Though JavaScript is inspired by Java (obviously), it's syntax is more like the language C and is based on ECMAScript, a scripting language developed by Sun Microsystems.\nOne thing (out of many) that stands out JavaScript from others is that it is a client-side scripting language, which means that the source code is not processed by the webserver, but by the web browser. This means JavaScript functions can run after a web page has loaded without communicating with the server.\nIts code can be inserted anywhere within the HTML of a webpage. However, only the output of server-side code is displayed in the HTML, while JavaScript code remains fully visible in the source of the webpage.",
  headerImage: headerImageJavaScript,
  technologyFeatures: {
    title: 'Features of Java Script',
    items: [
      {
        icon: JavaScriptIsEasyIcon,
        description:
          'JavaScript is easy, flexible, and a valuable scripting language that is used to enhance the functionality amidst websites.',
      },
      {
        icon: JavaScriptRichFrontEndIcon,
        description:
          'Provides rich front-end, no matter which technology you employ on the server.',
      },
      {
        icon: JavaScriptClientSideIcon,
        description:
          'Used on the client-side. Relieves strain on the web server',
      },
      {
        icon: JavaScriptProcessImmediatelyIcon,
        description:
          'Processing is done immediately, making JavaScript comparatively faster.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why JavaScript?',
    description:
      'It is used to convert static web pages that are created by using HTML and CSS into interactive ones. Its uses are',
    items: [
      {
        list: [
          'Responsive and interactive web pages',
          'Recognize the browsers that are being used by your visitor.',
          'Create cookies',
          'Validate forms as you are typing in the information.',
          'Create and add animation',
          'Allows you to draw on the web page itself using Canvas',
          'Integrate services like Facebook, Instagram and Twitter to the website.',
          'Load new images, objects or elements without needing to load the whole web page again.',
          'Improve visitor’s experience to a web page.',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: ResponsiveUIIcon,
        title: 'Responsive UI',
      },
      {
        icon: SeamlessIntegrationIcon,
        title: 'Seamless Integration',
      },
      {
        icon: FeatureRickWebsiteIcon,
        title: 'Feature-rich Website',
      },
      {
        icon: EasyMigrationIcon,
        title: 'Easy Migration',
      },
      {
        icon: BestInClassDevlopersIcon,
        title: 'Best-in-class Developers',
      },
      {
        icon: JavascriptAgileMethodologyIcon,
        title: 'Agile Methodology',
      },
      {
        icon: TrendingTechnologiesUsedIcon,
        title: 'Trending Technologies Used',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'JavaScript Web Development',
          'Single-Page Webapp',
          'JavaScript Software',
          'Social Networking Platforms',
          'Template Development',
        ],
      },
      {
        list: [
          'Plugin and Custom Widgets',
          'Customised JavaScript Solutions',
          'Enterprise Development',
          'Maintenance and Support',
          'Components Development',
        ],
      },
    ],
  },
};

const mongodb = {
  title: 'MongoDB',
  overview:
    "When you think of a database, this vague image comes onto our mind where we imagine it off like an Excel sheet. Well, you're right, that's exactly how it generally works until MongoDB came into existence. In MongoDB, the data objects are stored as separate documents inside a collection — instead of storing the data into the columns and rows of a traditional relational database and that's what makes it a document-oriented database. It is an open-source product, developed and supported by a company named 10gen.\nThe product which was first designed to serve commodity servers is now being used by the company of all sizes, across all industries.Since 2008, MongoDB has raised over $300 million in equity, which shows investors trust in its success.\nAt CodeMyMobile, with MongoDB development, we create mobile apps at a faster rate with any feature, data, and any device which scales to a large number of users.We help businesses migrate data from RDBMS like SQL Server, MySQL, DB2, Oracle and PostgreSQL to a NoSQL platform with MongoDB.Our expert consultants help you with a full range of services such as application development, migration to MongoDB and scaling existing deployments.\nTo correct issues related to query structure, data models, application design, etc., we have created the Real- Time Reporting system which does what it says, reports system details in real - time.",
  headerImage: headerImageMongoDB,
  technologyFeatures: {
    title: 'Features of MongoDB',
    items: [
      {
        icon: MongoDBRichFeatures,
        title: 'Rich Features',
        description:
          'The features of MongoDB like Graph processing, Text search, Geospatial, Analytics & Data Visualization, and global replication allows us to deliver a wide variety of real-time apps on one technology.',
      },
      {
        icon: MongoDBDuplication,
        title: 'Duplication',
        description:
          'It can run over various servers. The data is counterfeited to keep the system up and also keep its running condition in case of a hardware breakdown.',
      },
      {
        icon: MongoDBReplication,
        title: 'Replication',
        description:
          'It supports Master-Slave replication. A master can perform Reads and Writes and a Slave copies data from the master and can only be used for reads or back up.',
      },
      {
        icon: MongoDBFlexibility,
        title: 'Flexibility',
        description:
          'MongoDB document data model combines data of any structure and provides excellent flexibility to store.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why MongoDB?',
    items: [
      {
        list: ['Big Data Analytics', 'High Traffic Apps', 'Social Networks'],
      },
      {
        list: [
          'Document Oriented Systems',
          'Graph Storage Scenarios',
          'SmartMeters',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: MongoDBBackingUp,
        title: 'We track your databases for backing up your data.',
      },
      {
        icon: MongoDBMobileApps,
        title:
          'We use Xcode and Android SDK to develop robust mobile apps with MongoDB.',
      },
      {
        icon: MongoDBAgileDevelopmentMethodology,
        title: 'We provide the best suited Agile development methodology.',
      },
      {
        icon: MongoDBPersonalizationAtEveryStep,
        title: 'Personalization at every step.',
      },
      {
        icon: MongoDBWeProvideCleanCodes,
        title: 'We provide clean codes.',
      },
      {
        icon: MongoDBWeHelpBusinessesMigrate,
        title:
          'We help businesses migrate data from RDBMS to NoSQL like MongoDB',
      },
      {
        icon: MongoDBOurConsultantsEnable,
        title: 'Our consultants enable you to implement MongoDB solutions.',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'MongoDB Management Service',
          'MongoDB Migration',
          'MongoDB Consultation',
        ],
      },
      {
        list: [
          'MongoDB Implementation',
          'MongoDB Strategy',
          'Manage MongoDB Production',
        ],
      },
    ],
  },
};

const reactNative = {
  title: 'React Native',
  overview:
    "React Native is a cross-platform mobile app development framework that can ship native iOS and Android apps. One best (out of many) things about React Native is that along with its ability to develop applications for iOS, Android, Web and Windows Platform, it enables us, developers, to provide our clients with a complete seamless app as it gives us the advantage of enabling the use of React along with native platform capabilities. That's a win-win situation for both you and us. How? Imagine the use of ReactJS in development of a high-end user interface for your app which works flawlessly across all platforms. Why? Because it uses the device's native functionality without implying any add ons.\nBelieve us, React Native is the one- stop solution for building superfluid and powerful native mobile apps for iOS and Android.That’s the reason the best mobile apps in the world are made using React Native.\nAt CodeMyMobile, our skilled team of React Native developers holds in -depth knowledge to develop rational mobile apps best suited to drive your business, efficiently.",
  headerImage: headerImageReactNative,
  technologyFeatures: {
    title: 'Features of React Native',
    items: [
      {
        icon: ReactNativeCodeReusability,
        title: 'Code Reusability Reduces Overall Development Time',
        description:
          'Use of same code for building different platform apps, which makes it easier for us to manage the project, the project ends up being less buggy compared to other technology and lastly, you get your app much quicker.',
      },
      {
        icon: ReactNativeCoversTwoMajor,
        title: 'Covers Two Major Ecosystems',
        description:
          'Android and iOS. These two are entirely different ecosystems and the development of native applications for two different platforms is a tedious and painstaking task.',
      },
      {
        icon: ReactNativeIncorporateTheFunctionality,
        title: 'Incorporate the functionality of other native apps',
        description:
          'React Native is compatible with third-party plugins. For example, if you want to integrate Google Maps in your app, it could be done easily and without any hassles.',
      },
      {
        icon: ReactNativeShorterDevelopmentCycles,
        title: 'Shorter Development Cycles',
        description:
          'React Native allows developers to use a single codebase for multiple platforms, which can speed up development time',
      },
      {
        icon: ReactNativeUIFocused,
        title: 'UI-Focused',
        description:
          'React Native apps support a profoundly responsive interface. React Native and the native environment of the device reduces load times and gives a smoother feel of your app',
      },
      {
        icon: ReactNativeLiveUpdates,
        title: 'Live Updates and CodePush',
        description:
          `Live updates allow developers to make changes to their app's JavaScript code without having to go through the App Store or Google Play review process`,
      },
    ],
  },
  whyTechnology: {
    title: 'Why should you choose React Native?',
    items: [
      {
        icon: ReactNativeCostEffective,
        title: 'Cost-Effective',
        description: 'Due to code reusability.',
      },
      {
        icon: ReactNativeHighPerformance,
        title: 'High Performing Apps',
        description: 'As it collaborates well with the native environment',
      },
      {
        icon: ReactNativeSeamleassAnimations,
        title: 'Seamless Animations',
        description:
          'Again, because code is converted to native views before it is rendered.',
      },
      {
        icon: ReactNativeTrustedByBigBrands,
        title: 'Trusted By Big Brands',
        description: 'Facebook, Instagram, SoundCloud, you say it.',
      },
      {
        icon: ReactNativeNativeness,
        title: 'Nativeness',
        description: 'Focus on UI and Access to Native API out of the box.',
      },
      {
        icon: ReactNativeTransformation,
        title: 'Transformation',
        description: 'Transform any web project into a mobile decision easily.',
      },
      {
        icon: ReactNativeHugeSupport,
        title: 'Huge Support',
        description:
          "React Native backed by Facebook's product infrastructure engineering team along with Github support.",
      },
    ],
  },
  whyUs: {
    title: 'How are we more specialized?',
    items: [
      {
        list: [
          '5+ years of shipping React Native Apps ',
          'Business Expertise',
          'Round the Clock Supports',
        ],
      },
      {
        list: [
          'Best-in-class Developers',
          'Agile Methodology',
          'Trending Technologies Used',
        ],
      },
      {
        list: ['Result-Oriented Solutions', 'Fluid UI', 'Seamless Integration'],
      },
    ],
  },
  services: {
    title: 'Services we provide',
    items: [
      {
        list: [
          'Cross platform app development with React Native',
          'Delightful UI and UX development',
          'Android app development with React Native',
          'iOS app development with React Native',
        ],
      },
      {
        list: [
          'Cross platform React Native component development',
          'API development for mobile apps',
          'App support and maintenance',
          'Quality Assurance',
        ],
      },
    ],
  },
};

const reactJS = {
  title: 'ReactJS',
  overview:
    "Did you know many world-class projects like Facebook, Instagram, Yahoo!, Coursera, etc. built using ReactJS? With this being said, it clearly shows what marks have React left in today's world. \nIt is developed by Facebook and is developed for modern internet apps where multiple functions happen concurrently more responsive and high performing. \nHere at CodeMyMobile, we leverage the dynamism and adaptability of ReactJS for creating the interactive user interface of large scale enterprise applications.Our in -house team comprises highly skilled and tech- savvy ReactJS developers and industry veterans, who work together to create best-in -class ReactJS apps and solutions.We are the providers of one of the best ReactJS development services out there.",
  headerImage: headerImageReactJS,
  technologyFeatures: {
    title: 'Features of React',
    items: [
      {
        icon: ReactJSComponentBased,
        title: 'Component-Based',
        description:
          'Components let you split the user interface into autonomous and reusable pieces, then mould them to make complex UIs.',
      },
      {
        icon: ReactJSUsefulnessOfJFX,
        title: 'Usefulness of JFX',
        description:
          'It is a pre-step that adds XML language to JS which makes argumentation of a module more easygoing than ever.',
      },
      {
        icon: ReactJSDeclarative,
        title: 'Declarative',
        description:
          "Empowers you to manage the flow in your application by efficiently updating and providing the right components when there's a change in the data.",
      },
      {
        icon: ReactJSEasyLearningCurve,
        title: 'Easy Learning Curve:',
        description:
          'It is lightweight and easy to learn JS library, React executes projects cautiously to develop and maintain.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why should you choose React?',
    items: [
      {
        list: [
          'Useful developer tool for Chrome and Firefox',
          'Provides a user-friendly and faster single page application.',
          'Reduces the app development time and efforts (as it permits components to be used again and again.)',
          'Easier for you to deal with vast DOM data (as it renders a perfect blend of HTML tags and JavaScript)',
          'Provides ultimate development to your high-load web or mobile app.',
        ],
      },
    ],
  },
  whyUs: {
    title: 'How are we more specialized?',
    items: [
      {
        icon: ReactJSResponsiveUI,
        title: 'Responsive UI',
      },
      {
        icon: ReactJSSeamlessIntegration,
        title: 'Seamless Integration',
      },
      {
        icon: ReactJSFeatureRichWebsite,
        title: 'Feature-rich Website',
      },
      {
        icon: ReactJSEasyMigration,
        title: 'Easy Migration',
      },
      {
        icon: ReactJSBestInClassDevelopers,
        title: 'Best-in-class Developers',
      },
      {
        icon: ReactJSAgileMethodology,
        title: 'Agile Methodology',
      },
      {
        icon: ReactJSTrendingTechnologiesUsed,
        title: 'Trending Technologies Used',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Custom ReactJS Development',
          'Plug-ins Development',
          'Web Application Development',
          'Template Development',
          'Mobile App Development',
        ],
      },
      {
        list: [
          'UI Integration Existing App',
          'Enterprise Development',
          'Maintenance and Support',
          'Interactive UI Development',
          'Components Development',
        ],
      },
    ],
  },
};

const objectiveC = {
  title: 'Swift/Objective C',
  overview:
    "Those days are long gone when the iOS platform was just for iPhones and iPads. With so many other devices with iOS platform available in the market like Apple Watch, Apple Desktops, Apple TV, etc. the production of user-friendly apps which can work on multiple devices has become quite challenging. And that's where Swift and Objective C comes in handy. And we, of course. How? First, let's talk about Swift.\nSwift programming is considered as the most preferred programming language when it comes to developing apps for the iOS platform.It comprises several advanced features that ease developers to make development process efficient and fast.\nObjective C is a 30+ years old language which dates back to the 80s, so it’s very mature and has been tested by several generations of developers.When iOS first came into existence, all of its apps were developed on Java.Like everything else, with time, things need to move forward, and that’s when Swift was introduced by Apple in 2014.\nNow, why us? Our skilled team of iOS app developers has in-depth proficiency in iOS app development with Swift and Objective C.We can help you in overcoming the challenge of launching your app which is user- friendly as well as remarkably functional using a wide range of Apple devices.We ensure you to build prolific apps for your company that enhances your workability and profitability.\nBut wait, does Objective C still make sense in iOS development ? Yes, it does.Many of the iOS apps are still being developed by Objective C.So naturally, the maintenance they require needs a vast knowledge of Objective C.Here at CodeMyMobile, our Objective C developers help you in developing and maintaining your legacy projects.Looking to move your project from Objective C to Swift ? We got you.And if you have envisioned an app that doesn't have a very complicated UI, has a decent business logic and want an app for both iOS and Android platforms with similar UI, then you should definitely explore our React Native solutions.",
  headerImage: headerImageSwiftObjectiveC,
  technologyFeatures: {
    title: 'Features of Swift',
    items: [
      {
        icon: SwiftObjectiveCEasyAddOns,
        title: 'Easy Add-Ons',
        description:
          'Swift makes it very easy for us geeks to upgrade the features of your existing iOS application, thanks to our upgrading and updating skills.',
      },
      {
        icon: SwiftObjectiveCFastMethods,
        title: 'Fast Methods',
        description:
          "More features, less code. That's the mantra Swift makes coders follow because of its clear and powerful coding. This makes the job easier and quicker for the Swift programmers.",
      },
      {
        icon: SwiftObjectiveCModern,
        title: 'Modern',
        description:
          "It is a modern programming language which not only requires minimal coding but is easy and seamless for programmers to achieve even the most complex functionalities. And that's what makes it the most preferred programming language for the iOS developers.",
      },
      {
        icon: SwiftObjectiveCPerfectBlend,
        title: 'Perfect Blend',
        description:
          'Being a perfect blend of C and Objective-C, you can acquire stunning applications which have the capability of providing out-of-the-box UX.',
      },
    ],
  },

  technologyFeaturesOfC: {
    title: 'Features of C',
    items: [
      {
        icon: SwiftObjectiveCHighPerformance,
        title: 'High Performance',
        description:
          'Objective C is an interpreted language, which enhances it’s performance  with the use of just-in-time compiler.',
      },
      {
        icon: SwiftObjectiveCOfficailLanguage,
        title: 'Official Language',
        description:
          'It is the official language for iOS application development, so it would be a great choice to choose Objective C for iOS developers.',
      },
      {
        icon: SwiftObjectiveCDynamicTypinge,
        title: 'Dynamic Typing',
        description:
          'It is useful because we don’t always know beforehand what our objects are going to be at run-time. Dynamic typing in Objective-C is simple to use.',
      },
      {
        icon: SwiftObjectiveCExpressiveMessageSyntax,
        title: 'Expressive Message Syntax',
        description:
          'Message patterns in Objective-C are like natural language sentences with holes in them (prefixed with colons). This way of denoting messages comes from Smalltalk and makes the code very expressive.',
      },
    ],
  },

  whyObjectiveC: {
    title: 'Why Objective C?',
    items: [
      {
        list: [
          'Less error-prone',
          'Easy to Maintain',
          'Supported by multiple iOS operated devices',
          'Backed by dynamic libraries',
        ],
      },
      {
        list: [
          'Open-source',
          'Secure Programming',
          'Easy code readability and maintenance',
          'Speedy App Development',
          'Integrated Memory Management',
        ],
      },
    ],
  },

  whyUs: {
    title: 'Why us?',
    items: [
      {
        icon: SwiftObjectiveCCustomizedScalable,
        title: 'Customized & Scalable',
      },
      {
        icon: SwiftObjectiveCTransparentApproach,
        title: 'Transparent Approach',
      },
      {
        icon: SwiftObjectiveCUpdatedTechnologies,
        title: 'Updated Technology',
      },
      {
        icon: SwiftObjectiveCFocusedonBusinessGoals,
        title: 'Focused on Business Goals',
      },
      {
        icon: SwiftObjectiveCResultOrientedStrategy,
        title: 'Result Oriented Strategy',
      },
      {
        icon: SwiftObjectiveCOnTimeDelivery,
        title: 'On-time delivery',
      },
    ],
  },
  services: {
    title: 'Services we provide',
    items: [
      {
        list: [
          'Custom iOS Swift Development',
          'Designing Swift App',
          'Convert Objective-C App to Swift',
        ],
      },
      {
        list: [
          'Custom iPhone app solution',
          'Enterprise iPhone app solution',
          'iPhone app UI/UX Design',
        ],
      },
      {
        list: [
          'iPhone Widget/Extension Development',
          'iPhone app Support, Optimization, and Maintenance',
        ],
      },
    ],
  },
};

const wooCommerce = {
  title: 'WooCommerce',
  overview:
    'With remarkable, appealing and customer-friendly WooCommerce web stores, we, CodeMyMobile enhance the online business capability of your company. It is a WordPress plugin which has always remained an ideal choice for many retailers to start their online businesses. \nOur WooCommerce solutions are specially designed after intense market research and weighing insight into arising market trends. With an appealing shopping experience, exceptional functionalities, faster ROI, in-depth analytics, an uncomplicated check-out process, and an instinctive interface, we are a single hub for all your sales channels.',
  headerImage: headerImageExpressJS,
  whyTechnology: {
    title: 'Why WooCommerce?',
    items: [
      {
        icon: ShopifyEasySetupIcon,
        title: 'Access to completely free and extensive range of tools',
      },
      {
        icon: ShopifyFastSecureHostingIcon,
        title: 'Easy installation and availability of huge array of plugins',
      },
      {
        icon: ShopifyCustomerInfoSecuredIcon,
        title: 'Easy Customization',
      },
      {
        icon: ShopifyReviewsIcon,
        title: 'Detailed Sales and Performance Reporting',
      },
      {
        icon: ShopifySEOEfficientIcon,
        title: 'Out of the box multiple shipping options support',
      },
      {
        icon: ShopifySEOEfficientIcon,
        title: 'Exhaustive Tracking and Reporting',
      },
      {
        icon: ShopifySecurePaymentGatewayIcon,
        title: 'Secure payment gateway',
      },
      {
        icon: Shopify24x7AssistanceIcon,
        title: 'Full-fledged community support',
      },
      {
        icon: ShopifySEOEfficientIcon,
        title: 'SEO efficient',
      },
    ],
  },
  whyUs: {
    title: 'Why us?',
    items: [
      {
        icon: OutstandingUserExperienceIcon,
        title:
          'Outstanding User Experience across all intended platforms and devices',
      },
      {
        icon: MultPaymentOptionsSupportIcon,
        title: 'Multiple payment options supporting multiple currencies',
      },
      {
        icon: SecurityPCIComplianceSSLIcon,
        title:
          'Security from PCI Compliance to SSL Certificates to customized security modules',
      },
      {
        icon: EasyContentManagementIcon,
        title: 'Easily management content',
      },
      {
        icon: WarehouseInventoryManagementIcon,
        title: 'Warehouse and Inventory Management',
      },
      {
        icon: RobustBugFreeStoreIcon,
        title: 'A robust & bug-free WooCommerce store',
      },
      {
        icon: ScalableSolutionIcon,
        title: 'A Scalable Solution',
      },
      {
        icon: ModernUIUXIcon,
        title: 'Modern UI/UX to captivate your visitors',
      },
      {
        icon: EngagingExperienceIcon,
        title: 'An engaging experience for your buyers',
      },
      {
        icon: CustomizeAllNeedsIcon,
        title: 'Customize All You Need',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'WooCommerce Implementation',
          'WooCommerce Migration',
          'WooCommerce Theme Development',
        ],
      },
      {
        list: [
          'WooCommerce Web Design',
          '3rd Party API Integration',
          'Module and Plugin development',
        ],
      },
      {
        list: [
          'WooCommerce Subscriptions Plugin Development',
          'WooCommerce Payment Gateway Integration',
          'WooCommerce Support and Maintenance',
        ],
      },
    ],
  },
};

const javaKotlin = {
  title: 'Java/Kotlin',
  overview: `Java is a 20+ years old language and still the second most used language. It is intended to let application developers ‘write once, run anywhere’ (WORA), meaning that compiled Java code can run on all platforms that support Java without the need for recompilation. When Android first came into existence, all of its apps were developed on Java. Like everything else, with time, things need to move forward, and that’s when Kotlin came into existence. 
So step aside Java, Kotlin for Android is here. Kotlin is now first-class supported language on Android and is designed to build code that interoperates with Java. And the best part is, it is officially supported by Google. From decrement in bugs to improvement in the readability of code and lessening of the development time, Kotlin is undoubtedly a rising star for the Android mobile application development. 
Kotlin development is fairly new and the skill comes at a cost, there aren't many top-notch developers out there who can provide you with a seamless Android app you've been dreaming of, but fret not! We are here.
Making the best usage of the Kotlin features, here at CodeMyMobile, our Kotlin developers improve the development speed while keeping the code to the minimum. We are equipped with Kotlin methodologies to offer the most sophisticated solution to our clients.
But wait, does Java still make sense in Android development? Yes, it does. Most of the Android apps are still running on Java. So naturally, the maintenance they require needs a vast knowledge of Java.  Here at CodeMyMobile, our Java developers help you in developing and maintaining your legacy projects. Looking to move your project from Java to Kotlin? We got you. And if you have envisioned an app that doesn't have a very complicated UI, has a decent business logic and want an app for both Android and iOS platforms with similar UI, then you should definitely explore our React Native solutions.`,
  headerImage: JavaHeaderImage,
  technologyFeatures: {
    title: 'Features of Java',
    items: [
      {
        icon: JavaSecureIcon,
        title: 'Secure',
        description:
          'When it comes to security, Java is always the first choice. With java secure features it enables us to develop virus free, tamper free system.',
      },
      {
        icon: JavaHighPerformance,
        title: 'High Performance',
        description:
          'Java is an interpreted language, which enhances it’s performance  with the use of just-in-time compiler.',
      },
      {
        icon: JavaMultiThreaded,
        title: 'Multi-Threaded',
        description:
          "The main advantage of multi-threading is that it doesn't occupy memory for each thread. Threads are important for multimedia.",
      },
      {
        icon: JavaDynamic,
        title: 'Dynamic',
        description:
          'Java supports dynamic compilation and automatic memory management which means classes are loaded on demand without any hindrance.',
      },
    ],
  },
  technologyFeaturesAlternate: {
    title: 'Features of Kotlin',
    items: [
      {
        icon: JavaRichPerformance,
        title: 'Rich Performance',
        description:
          'Apps written in Kotlin run faster on Android 10 than its earlier version because of D8 – Dexer compiler. Dexer came into existence way after Java and hence is much effcient. This makes it more common than Java among developers.',
      },
      {
        icon: JavaInteroperable,
        title: 'Interoperable',
        description:
          'Kotlin programing language allows migration of large Java codebases to Kotlin. Kotlin is 100% interoperable in Java. So, your existing Java code can be used with Kotlin, and you do not have to develop your existing Java app in Kotlin again.',
      },
      {
        icon: JavaErrorFree,
        title: 'Error-Free Multithreading',
        description:
          'Kotlin enables developers to use pure functions and immutable objects, which eliminates continuous modification of similar data by multiple threads when there is no synchronization causing errors.',
      },
      {
        icon: JavaOfficialLanguage,
        title: 'Official Language',
        description:
          'It is the official language for Android application development by Google, so it would be a great choice to choose Kotlin for Android developers.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why Java/Kotlin?',
    items: [
      {
        list: [
          'Supports various IDE',
          'Modern and Expressive',
          'Interoperability with Java',
          'Highly Scalable',
        ],
      },
      {
        list: [
          'Easy Migration',
          'Less Redundancy, Fewer Errors',
          'Secure & Trustworthy',
          'Interoperability with Java',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: JavaHighlySkill,
        title: 'Highly skilled & experienced Kotlin developers',
      },
      {
        icon: JavaKotlinTeam,
        title: 'Dedicated Kotlin team',
      },
      {
        icon: JavaFixedCost,
        title: 'Flexibility to choose hourly or fixed-cost engagement',
      },
      {
        icon: JavaSeamless,
        title: 'Seamless communication',
      },
      {
        icon: JavaDisclosure,
        title: 'Non-Disclosure Agreement',
      },
      {
        icon: JavaOnTimeDelivery,
        title: 'On-time delivery of the project',
      },
      {
        icon: JavaTechnicalSupport,
        title: 'Technical support',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Support and Maintenance',
          'Migration to Kotlin',
          'Testing Kotlin Apps',
        ],
      },
      {
        list: [
          'Android App Development with Kotlin',
          'Application Optimization with Kotlin',
          'Upgrading Kotlin Apps',
        ],
      },
    ],
  },
};

const nodejs = {
  title: 'NodeJS',
  overview: `No matter how attractive your motorbike is, without an effective engine, it won't turn you into the king of the streets. Similarly, no matter how appealing your frontend is, without an efficient backend, it will be a mess. A neat frontend is not enough, you need a robust backend to carry out functions on the server.
NodeJS is used in creating data-intensive and real-time applications that function across various devices. It is an open-source platform utilized mostly for crafting server-side and networking apps. Widely used for creating reliable and faster server tools and network apps, Node.JS serves as a powerful tool to create excellent results.
Okay, so now, yes, we'll confess, we might not be able to help you in turning you into the ultimate street racer, but here at CodeMyMobile, we definitely can provide you top-notch development services for your backend solutions. By recruiting our services, you can deploy cutting-edge Node.js applications to your business.`,
  headerImage: NodeHeaderImage,
  whyTechnology: {
    title: 'Features of NodeJS',
    items: [
      {
        icon: NodeWebEfficient,
        title: 'Website efficient',
      },
      {
        icon: NodeEasyInstall,
        title: 'Easy installation and execution',
      },
      {
        icon: NodeScalable,
        title: 'Scalable development',
      },
      {
        icon: NodeEcomm,
        title: 'Swift eCommerce site handling',
      },
      {
        icon: NodeParsingTime,
        title: 'Reduced parsing time',
      },
      {
        icon: NodeAllPlatform,
        title: 'Compatibility on all platforms',
      },
      {
        icon: NodeServerSide,
        title: 'Networking applications connected to server-side',
      },
      {
        icon: NodeAPIIntegration,
        title: 'API integration and development',
      },
      {
        icon: NodeCustomisedApp,
        title: 'Customised apps',
      },
      {
        icon: NodeCloud,
        title: 'Hosted on cloud',
      },
      {
        icon: NodeMultipleApp,
        title: 'Multiple application support',
      },
    ],
  },
  whyUs: {
    title: 'NodeJS can be used for',
    items: [
      {
        icon: NodeContentPortal,
        title: 'Content management portals',
      },
      {
        icon: NodePlugin,
        title: 'Plugins development',
      },
      {
        icon: NodeChatApp,
        title: 'Chat applications',
      },
      {
        icon: NodeRealTime,
        title: 'Real-time statistics display applications',
      },
      {
        icon: NodeEcommPortal,
        title: 'eCommerce portals',
      },
      {
        icon: NodeMonitoring,
        title: 'System monitoring applications',
      },
      {
        icon: NodeDateIntensiveApp,
        title: 'Light-weight data-intensive apps',
      },
      {
        icon: NodeCreateMarket,
        title: 'Creating Marketplace',
      },
      {
        icon: NodeAjaxDev,
        title: 'Ajax development',
      },
      {
        icon: NodeWebAPI,
        title: 'Web APIs',
      },
      {
        icon: NodeRealTimeApps,
        title: 'Real-time apps',
      },
      {
        icon: NodeAPIPs,
        title: 'APIs',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Node.JS Web/Mobile App',
          'Node.JS App Customization',
          'Node.JS Packages',
          'Node.JS and MongoDB',
        ],
      },
      {
        list: [
          'Chatbot Development',
          'Back-end and Front-endS',
          'Real-time Application',
          'Interactive Dashboard',
        ],
      },
      {
        list: [
          'Module & Plug-in development',
          'Shopify Web Design',
          'Shopify Support and Maintenance',
        ],
      },
    ],
  },
};

const postgre = {
  title: 'PostgreSQL',
  overview: `As one of the most powerful, open-source database systems available, PostgreSQL has benefited organizations worldwide with more than 15 years of reliability, security, data integrity, support, and service. It emphasizes extensibility and technical standards compliance and is the default database for macOS Server.
PostgreSQL database care helps your business increase performance and security. On our team, CodeMyMobile has built speciality groups to incorporate query tuning, execution & SAN setup, warehouse & BI, .net development and business value translation.
We at CodeMyMobile strongly believe that the future lies in Open-source Stack community editions. Our leadership lies implementing solutions using open-source databases like PostgreSQL and help customers in migrating off from proprietary databases and supporting them in their business growth and continuity.
CodeMyMobile has in-depth implementations by handling terabytes of data for mission-critical applications for our satisfied customers. We enriched PostgreSQL deployment in various domains like telecom, IoT, healthcare, data science, government, e-commerce, aviation and many more.`,
  headerImage: PostgreHeader,
  technologyFeatures: {
    title: 'Features of PostgreSQL',
    items: [
      {
        icon: PostgreCompatible,
        title: 'Compatible',
        description:
          'It is compatible to run on many operating systems, like Novell NetWare, Windows, Linux and others.',
      },
      {
        icon: PostgreSupport,
        title: 'Support',
        description:
          'PostgreSQL supports a lot of features of SQL like Complex SQL queries, SQL Sub-selects, Foreign keys, Trigger, Views, Transactions, etc.',
      },
      {
        icon: PostgreSecure,
        title: 'Secure',
        description:
          'It consists of a solid data security layer that protects sensitive data from intruders. Passwords are encrypted in MySQL.',
      },
      {
        icon: PostgreVariety,
        title: 'Variety',
        description:
          'PostgreSQL supports text, images, tones, and video, and incorporates interfaces for C / C++, Java, Perl, Python, Ruby, Tcl and ODBC.',
      },
    ],
  },
  whyTechnology: {
    title: 'Why PostgreSQL?',
    items: [
      {
        list: [
          'Support ACID (Atomicity, Consistency, Isolation, Durability).',
          'Diverse indexing techniques',
          'Variety of replications available',
          'Capacity for fault tolerance',
          'Supports Multi-version concurrency control (MVCC).',
          'Carries different kinds of techniques for geographic data storage',
          'Recovery is high',
        ],
      },
    ],
  },
  whyUs: {
    items: [
      {
        icon: PostgreWorldClass,
        title: 'World-class developers',
      },
      {
        icon: PostgreClientSatifaction,
        title: 'Deliver ultimate client satisfaction',
      },
      {
        icon: PostgreDatabase,
        title: 'We track your databases for backing up your data.',
      },
      {
        icon: PostgreMobileApp,
        title:
          'We use Xcode and Android SDK to develop robust mobile apps with MySQL.',
      },
      {
        icon: PostgreAgileDev,
        title: 'We provide the best suited Agile development methodology.',
      },
      {
        icon: PostgrePersonalization,
        title: 'Personalization at every step.',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'PostgreSQL Management Service',
          'PostgreSQL Migration',
          'PostgreSQL Consultation',
        ],
      },
      {
        list: [
          'PostgreSQL Implementation',
          'PostgreSQL Strategy',
          'Manage PostgreSQL Production',
        ],
      },
    ],
  },
};

const TechnologiesPage = {
  heading: 'Modern Problems require Modern Solutions, We provide them, Easy',
  overview:
    'From basics to path-breaking technologies, we hack all of them with sheer precision and excellence. We work on varied platforms and new age technologies. Our solutions are highly scalable and we promise seamless integrations.',
  technology: {
    list: [
      {
        title: 'Mobile',
        text: 'No matter what’s the platform or the device, We build an app for that. Starting from custom, native iOS, Android, Hybrid or Windows Apps, we do it all. We build apps that are successful. We bring together smart business strategies, captivating UI/UX design and a robust tech team. Our development team is backed by powerful agile methodologies and rapid launch marketing.',
        subTechnology: [
          {
            title: 'Android - Java/Kotlin',
            pageLink: '/industries/fintech',
          },
          {
            title: 'iOS - Swift/Objective C',
            pageLink: '',
          },
          {
            title: 'React Native',
            pageLink: '',
          },
          {
            title: 'Flutter',
            pageLink: '',
          },
          {
            title: 'NativeScript',
            pageLink: '',
          },
          {
            title: 'Kotlin',
            pageLink: '',
          },
        ],
      },
      {
        title: 'UI',
        text: 'This is one of our core strengths and we would not hesitate to brag about it to. Starting from the ideation to wireframing to prototypes we build a world that feels too good to be true. The best tools and technologies along with effective communication form the strength of our process. We make sure every app we build is uniquely attractive and beautiful.',
        subTechnology: [
          {
            title: 'Angular',
            pageLink: '',
          },
          {
            title: 'React',
            pageLink: '',
          },
          {
            title: 'Vue.js',
            pageLink: '',
          },
          {
            title: 'TypeScript',
            pageLink: '',
          },
          {
            title: 'Javascript',
            pageLink: '',
          },
          {
            title: 'Wordpress',
            pageLink: '',
          },
          {
            title: 'HTML5',
            pageLink: '',
          },
          {
            title: 'CSS',
            pageLink: '',
          },
          {
            title: 'Polymer',
            pageLink: '',
          },
          {
            title: 'GatsbyJS',
            pageLink: '',
          },
          {
            title: 'Jekyll',
            pageLink: '',
          },
        ],
      },
      {
        title: 'e-Commerce',
        text: 'We will help your eCommerce venture get off the ground with full speed. Our past experience and delivery of many extraordinary solutions give us an edge to make your business succeed. We build beautiful storefront that has powerful management system and is mobile optimized.',
        subTechnology: [
          {
            title: 'Magento',
            pageLink: '',
          },
          {
            title: 'Shopify',
            pageLink: '',
          },
          {
            title: 'WooCommerce',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Backend',
        text: 'Any application, (mobile or web) needs a place to store, manipulate and serve data as and when required. Where is all that data stored? This is where the back-end comes in. A typical back-end of an application consists of an HTTP server, an application server, and a database server.The back-end contains the business logic that works behind the scenes to drive your application.\n At CodeMyMobile, our back-end experts have ample experience to decide which framework, which programming language would be best suited for your application based on a lot of factors like scalability, performance, future updates, etc.',
        subTechnology: [
          {
            title: 'Node.JS',
            pageLink: '',
          },
          {
            title: 'Express',
            pageLink: '',
          },
          {
            title: 'Nxt.js',
            pageLink: '',
          },
          {
            title: 'Python',
            pageLink: '',
          },
          {
            title: 'Django',
            pageLink: '',
          },
          {
            title: 'Flask',
            pageLink: '',
          },
          {
            title: 'Go Lang',
            pageLink: '',
          },
          {
            title: 'Ruby on Rails',
            pageLink: '',
          },
          {
            title: 'Laravel',
            pageLink: '',
          },
          {
            title: 'CodeIgniter',
            pageLink: '',
          },
          {
            title: 'PHP',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Databases',
        text: 'Choosing the right database engine for your application is crucial. Our developers have proven experience in the field of the database. Having an in-depth understanding of data management, knowledge of app development and hands-on experience in SQL, when all these attributes are combined, you get a full easy-to-manage and secure database. We have experience of working from old-house technologies like MongoDB, MySQL, Redis, etc. to modern ones like Neo4j, Memcached, InfluxDB, etc.',
        subTechnology: [
          {
            title: 'MongoDB',
            pageLink: '',
          },
          {
            title: 'MariaDB',
            pageLink: '',
          },
          {
            title: 'MySQL',
            pageLink: '',
          },
          {
            title: 'Postgresql',
            pageLink: '',
          },
          {
            title: 'Elastic Search',
            pageLink: '',
          },
          {
            title: 'Solr',
            pageLink: '',
          },
          {
            title: 'Redis',
            pageLink: '',
          },
          {
            title: 'InfluxDB',
            pageLink: '',
          },
          {
            title: 'Cassandra',
            pageLink: '',
          },
          {
            title: 'Neo4j',
            pageLink: '',
          },
          {
            title: 'Memcached',
            pageLink: '',
          },
        ],
      },
      {
        title: 'DevOps',
        text: 'With the advent of Cloud Computing and cloud architectures like SaaS, PaaS, etc, Companies have started incorporating DevOps practices instead of the traditional waterfall method of deploying and releasing applications.\n With modern applications running in the cloud, much of what used to be considered infrastructure is now part of the code. Classic big WebOps shops like Google, Amazon, Twitter and Etsy are known to do deployments multiple times a day. To deploy that often, you have to know you’re not going to break what’s already working. DevOps helps ensure frequent deploys with a low failure rate.',
        subTechnology: [
          {
            title: 'Docker',
            pageLink: '',
          },
          {
            title: 'Kubernetes',
            pageLink: '',
          },
          {
            title: 'Docker Swarm',
            pageLink: '',
          },
          {
            title: 'OpenShift',
            pageLink: '',
          },
          {
            title: 'CircleCI',
            pageLink: '',
          },
          {
            title: 'Jenkins',
            pageLink: '',
          },
          {
            title: 'TravisCI',
            pageLink: '',
          },
          {
            title: 'FireCI',
            pageLink: '',
          },
          {
            title: 'Ansible',
            pageLink: '',
          },
          {
            title: 'Nagios',
            pageLink: '',
          },
          {
            title: 'Chef',
            pageLink: '',
          },
          {
            title: 'Puppet',
            pageLink: '',
          },
          {
            title: 'LogStash',
            pageLink: '',
          },
          {
            title: 'Terraform',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Testing',
        text: 'We try our best to provide you with a bug-free experience. We use an integrated flexible testing process, we test all use cases, problematical edge cases, and all operative and visual aspects in the software lifecycle.\n We offer sturdy application testing that includes manual testing, visual quality assurance, and mechanised testing to ensure that your app works faultlessly and retains users.',
        subTechnology: [
          {
            title: 'Appium',
            pageLink: '',
          },
          {
            title: 'Selenium',
            pageLink: '',
          },
          {
            title: 'Sahi',
            pageLink: '',
          },
          {
            title: 'Apache JMeter',
            pageLink: '',
          },
          {
            title: 'BrowserStack',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Integrations',
        text: 'App lacking features? Say no more. We excel at integrating various different aspects and functionality in your app. With the use of modern technologies like Twilio, Auth0, OneLogin, Okta, Sentry and many more, our fully is exceptionally component for providing you with an app with multiple functionalities.',
        subTechnology: [
          {
            title: 'Twilio',
            pageLink: '',
          },
          {
            title: 'Instana',
            pageLink: '',
          },
          {
            title: 'New Relic',
            pageLink: '',
          },
          {
            title: 'DataDog',
            pageLink: '',
          },
          {
            title: 'Mandrill',
            pageLink: '',
          },
          {
            title: 'MailChimp',
            pageLink: '',
          },
          {
            title: 'Sendgrid',
            pageLink: '',
          },
          {
            title: 'Plivo',
            pageLink: '',
          },
          {
            title: 'Auth0',
            pageLink: '',
          },
          {
            title: 'Firebase',
            pageLink: '',
          },
          {
            title: 'OneLogin',
            pageLink: '',
          },
          {
            title: 'Okta',
            pageLink: '',
          },
          {
            title: 'Metabase',
            pageLink: '',
          },
          {
            title: 'Slack',
            pageLink: '',
          },
          {
            title: 'Segment',
            pageLink: '',
          },
          {
            title: 'Google Analytics',
            pageLink: '',
          },
          {
            title: 'Sentry',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Cloud Ops',
        text: "Migrating applications to the cloud bring its benefits, such as freeing up internal infrastructure, and that's why we know how much important it is for our clients. From moving things to cloud to managing it, our experts cover it all. We manage configurations, allocate resources, optimise cloud performance capacity, manage compliance burden, ensure service-level-agreements (SLAs) are being met, etc.",
        subTechnology: [
          {
            title: 'Google Cloud',
            pageLink: '',
          },
          {
            title: 'Azure',
            pageLink: '',
          },
          {
            title: 'Digital Ocean',
            pageLink: '',
          },
          {
            title: 'Alibaba Cloud',
            pageLink: '',
          },
          {
            title: 'Oracle Cloud',
            pageLink: '',
          },
          {
            title: 'OVH',
            pageLink: '',
          },
          {
            title: 'Mirantis',
            pageLink: '',
          },
          {
            title: 'Heroku',
            pageLink: '',
          },
          {
            title: 'Amazon Web Services (AWS)',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Payments',
        text: 'Making transactions faster is one thing and making them safer is another, but the good news is, we excel at both.  With so much to be done in the field of payment, our team provides you services from online bank to mutual funds marketplace to money transfer/e-wallet app development, we got it all.',
        subTechnology: [
          {
            title: 'Stripe',
            pageLink: '',
          },
          {
            title: 'Paypal',
            pageLink: '',
          },
          {
            title: 'BrainTree',
            pageLink: '',
          },
          {
            title: 'RazorPay',
            pageLink: '',
          },
          {
            title: 'BillDesk',
            pageLink: '',
          },
        ],
      },
      {
        title: 'Security',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        subTechnology: [
          {
            title: 'HashiCorp Vault',
            pageLink: '',
          },
          {
            title: 'Amazon KMS',
            pageLink: '',
          },
          {
            title: 'Amazon GuardDuty',
            pageLink: '',
          },
          {
            title: 'Azure KMS',
            pageLink: '',
          },
        ],
      },
      {
        title: 'More',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        subTechnology: [
          {
            title: 'TensorFlow',
            pageLink: '',
          },
          {
            title: 'Pandas',
            pageLink: '',
          },
          {
            title: 'Kibana',
            pageLink: '',
          },
          {
            title: 'Grafana',
            pageLink: '',
          },
          {
            title: 'Prometheus',
            pageLink: '',
          },
          {
            title: 'RabbitMQ',
            pageLink: '',
          },
          {
            title: 'Celery',
            pageLink: '',
          },
          {
            title: 'Nginx',
            pageLink: '',
          },
          {
            title: 'HAProxy',
            pageLink: '',
          },
          {
            title: 'Apache',
            pageLink: '',
          },
          {
            title: 'Kong',
            pageLink: '',
          },
          {
            title: 'Tyk',
            pageLink: '',
          },
          {
            title: 'OpenLiteSpeed',
            pageLink: '',
          },
          {
            title: 'Parse Platform',
            pageLink: '',
          },
          {
            title: 'BlockChain',
            pageLink: '',
          },
          {
            title: 'Solidity',
            pageLink: '',
          },
          {
            title: 'Augmented Reality',
            pageLink: '',
          },
        ],
      },
    ],
  },
  technologies: [
    aws,
    mongodb,
    reactNative,
    docker,
    elasticSearch,
    angularJS,
    reactJS,
    googleCloud,
    django,
    gatsbyJS,
    laravel,
    shopify,
    expressJS,
    javaKotlin,
    nodejs,
    postgre,
    mysql,
    wooCommerce,
    objectiveC,
    javascript,
  ],
  navigation: {
    prev: {
      title: 'Technology',
      overview:
        'From basics to path-breaking technologies, we hack all of them with sheer precision and excellence. We work on varied platforms and disruptive technologies',
    },
    next: {
      title: 'Process',
      overview:
        'Processes always remains our core, whether its helping entreprises iterate like startups or scaling startups like established brands',
    },
  },
  subPage: {
    aws,
    mongodb,
    reactNative,
    docker,
    elasticSearch,
    angularJS,
    reactJS,
    googleCloud,
    django,
    gatsbyJS,
    laravel,
    shopify,
    expressJS,
    javaKotlin,
    nodejs,
    postgre,
    mysql,
    wooCommerce,
    objectiveC,
    javascript,
  },
};

export default TechnologiesPage;
